export const italianTranslation = {
  'Les lignes de commandes ont été mises à jour avec succès !':
    'Le linee di comando sono state aggiornate con successo!',
  'Le texte a été enregistré avec succès':
    'Il testo è stato registrato con successo',
  'La traduction a été enregistrée avec succès':
    'La traduzione è stata salvata con successo',
  'Texte + Traduction enregistré avec succès':
    'Testo + Traduzione è stata salvata con successo',
  'Nombre de mots': 'Numero di parole',
  Lingala: 'Lingala',
  'Prénom/Nom du client': 'Nome e cognome del cliente',
  Bashkir: 'Bashkir',
  "La date doit être ultérieure à aujourd'hui.":
    'La data deve essere successiva a quella di oggi.',
  'Contenu rédigé': 'Contenuto scritto',
  'Nom/prénom': 'Cognome/nome',
  'Mot de passe incorrect': 'Password errata',
  Institutions: 'Istituzioni',
  'Veuillez donner un descriptif au document téléchargé':
    'Si prega di fornire una descrizione del documento scaricato',
  'Sichuan Yi ; Nuosu': 'Sichuan Yi; Nuosu',
  Suivant: 'Avanti',
  Kannada: 'Kannada',
  'Séparer les mots clés par un "enter"':
    'Separare le parole chiave con un "enter".',
  Allemand: 'Tedesco',
  Sango: 'Sango',
  'Min.': 'Min.',
  'un email contenant un lien de réinitialisation du mot de passe a été envoyé à votre email':
    "è stata inviata al vostro indirizzo e-mail un'e-mail contenente un link per la reimpostazione della password",
  'Chef edito': 'Capo redattore',
  Croate: 'Croato',
  'Nb de textes': 'Numero di testi',
  Violet: 'Viola',
  'Ce champs doit être sup ou égale nombre de texte':
    'Questo campo deve essere maggiore o uguale al numero di testo',
  'a été activé avec succès': 'è stato attivato con successo',
  Népalais: 'Nepalese',
  'Nombre de FAQ': 'Numero di FAQ',
  Urdu: 'Urdu',
  'Analyses restantes': 'Analisi rimanenti',
  Indonésien: 'Indonesiano',
  Breton: 'Bretone',
  Livrés: 'Consegnato',
  Associations: 'Associazioni',
  'Le client': 'Il cliente',
  'Révision demandée': 'Richiesta di revisione',
  "Une erreur s'est produite, veuillez réessayer":
    'Si è verificato un errore, riprovare',
  'Mise à jour non autorisée car des textes ont été livrés':
    'Aggiornamento non autorizzato in quanto i testi sono stati consegnati',
  "Pour ajouter un texte (optimisation d'un contenu existant)":
    'Per aggiungere testo (ottimizzare i contenuti esistenti)',
  Gaélique: 'Gaelico',
  'La ligne de commande pour': 'La riga di comando per',
  'Business/Management': 'Affari/Gestione',
  Serbe: 'Serbo',
  "Merci d'indiquer ci-dessous vos demandes de modifications en prenant bien en compte nos conditions de repasses":
    'Vi preghiamo di indicare qui di seguito le vostre richieste di modifica, tenendo conto delle nostre condizioni di stiratura',
  'rédacteurs trouvés': 'scrittori trovati',
  'Kirghiz ; Kirghiz': 'Kirghiz; Kirghiz',
  Différence: 'Differenza',
  'en cours': 'in corso',
  'Sami du Nord': 'Sami del Nord',
  Comparer: 'Confronto',
  Lituanien: 'Lituano',
  'Typix - Mon tableau de bord': 'Typix - Il mio cruscotto',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un charactère spécial et ne pas être identique au nom':
    'Deve essere lungo almeno 8 caratteri con una lettera maiuscola, un numero, un carattere speciale e non identico al nome.',
  Webmaster: 'Webmaster',
  'Veuillez saisir des champs valides': 'Inserire campi validi',
  Basque: 'Basco',
  'Exporter .csv': 'Esportazione .csv',
  'Confirmer le nouveau mot de passe': 'Confermare la nuova password',
  "Pas d'options": 'Nessuna opzione',
  'Banque/Assurance': 'Banche/Assicurazioni',
  'Vos demandes': 'Le vostre richieste',
  'Coût d\u2019achat': 'Costo di acquisto',
  Tamil: 'Tamil',
  'Le texte a été supprimé avec succès':
    'Il testo è stato cancellato con successo',
  'Mes Commandes': 'I miei ordini',
  Zoulou: 'Zulu',
  Afficher: 'Vista',
  Texte: 'Testo',
  Islandais: 'Islandese',
  Russe: 'Russo',
  'Tous les textes': 'Tutti i testi',
  Czech: 'Ceca',
  'Comparaison hors ligne': 'Confronto offline',
  Téléphonie: 'Telefonia',
  'Valider le texte': 'Convalidare il testo',
  'Votre text ne de doit pas dépasser 500 mots':
    'Il testo non deve superare le 500 parole',
  'Coquilles (double espace, « s »\u2026)':
    'Conchiglie (doppio spazio, "s"...)',
  'le consultant': 'il consulente',
  Coréen: 'Coreano',
  'Nb de Silo': 'Numero di silos',
  Validés: 'Convalidato',
  'non attribuées': 'non allocato',
  Néerlandais: 'Olandese',
  'Voulez-vous vraiment supprimer': 'Volete davvero cancellare',
  Rundi: 'Rundi',
  Regional: 'Regionale',
  'Compte client': 'Conto cliente',
  Global: 'Globale',
  'Tous les rôles': 'Tutti i ruoli',
  Musique: 'Musica',
  Perso: 'Personale',
  Kinyarwanda: 'Kinyarwanda',
  'Il semblerait que tu n\u2019aies plus de crédit d\u2019analyse':
    'Sembra che non abbiate più credito di analisi',
  Bambara: 'Bambara',
  Sortir: 'Esci',
  optionel: 'opzionale',
  'Temps restant': 'Tempo rimanente',
  Ukrainien: 'Ucraino',
  'Chichewa ; Chewa ; Nyanja': 'Chichewa; Chewa; Nyanja',
  'Votre demande de révision a bien été envoyée.':
    'La richiesta di revisione è stata inviata.',
  'Typix - Créer rédacteur': 'Typix - Creare un scrittore',
  "n'existe pas": 'non esiste',
  Hindi: 'Hindi',
  'ne peut pas être supprimé car il est lié à des sites web':
    'non può essere cancellato perché è collegato a siti web',
  'Commandes en cours': 'Ordini in corso',
  'Textes livrés': 'Testi consegnati',
  Validation: 'Convalida',
  'Non attribuées': 'Non assegnato',
  'Voulez-vous vraiment désactiver': 'Si vuole davvero disattivare',
  'Catalan ; Valencien': 'Catalano; Valenciano',
  'Nombre de textes restants': 'Numero di testi rimanenti',
  'Ne doit pas contenir votre nom': 'Non deve contenere il vostro nome',
  Documentation: 'Documentazione',
  Kazakh: 'Kazako',
  'Numéro invalide': 'Numero non valido',
  'Veuillez saisir un texte ou importer un fichier.':
    'Inserire un testo o importare un file.',
  'Nb de FAQ': 'Numero di FAQ',
  Analyser: 'Analizzare',
  Turc: 'Turco',
  'Toute demande n\u2019ayant pas été précisée lors du brief':
    'Qualsiasi richiesta non specificata nel documento',
  Wallon: 'Vallonia',
  Birmane: 'Birmano',
  Irlandais: 'Irlandese',
  Oriya: 'Oriya',
  'Réinitialiservotre mot de passe': 'Reimpostare la password',
  Cuisine: 'Cucina',
  'Haïtien ; créole haïtien': 'Haitiano; creolo haitiano',
  'Vous ne pouvez pas supprimer le rédacteur':
    "Non è possibile eliminare l'scrittore",
  Validé: 'Convalidato',
  "cet email n'existe pas": 'questa email non esiste',
  Historique: 'La storia',
  Confirmer: 'Confermare',
  'à cocher si le nombre de mots est différent par texte':
    'da spuntare se il numero di parole è diverso per ogni testo',
  'Fiche du site web ': 'Scheda del sito web',
  Désactiver: 'Disattivare',
  'Travaux/BTP': 'Lavori/Costruzioni',
  'La fiche du website': 'La scheda del sito web',
  'Si le contenu ne respecte pas les règles du brief':
    'Se il contenuto non rispetta le regole del brief',
  Norvégien: 'Norvegese',
  '0 rédacteurs': '0 scrittori',
  indisponible: 'non disponibile',
  Venda: 'Venda',
  Maori: 'Maori',
  'Textes revisés': 'Testi rivisti',
  'Status texte': 'Stato del testo',
  'textes livrés en attente de validation':
    'testi consegnati in attesa di convalida',
  'Typix - Mon Profile': 'Typix - Il mio profilo',
  'le client': 'il cliente',
  Romanche: 'Romanche',
  'URL du site': 'URL del sito',
  'nouvelles notifications': 'nuove notifiche',
  'Divehi ; Dhivehi ; Maldivien': 'Divehi; Dhivehi; Maldiviano',
  'Êtes vous sur de vouloir sauvegarder le texte':
    'Siete sicuri di voler salvare il testo',
  'Veuillez ajouter un texte initiale afin de pouvoir sauvegarder le texte en brouillon':
    'Si prega di aggiungere un testo iniziale per salvare il testo come bozza',
  Xhosa: 'Xhosa',
  'Le contrat pour le client': 'Il contratto per il cliente',
  rédacteurs: 'scrittori',
  'Ce champ est obligatoire': 'Questo campo è obbligatorio',
  'Tarif/Mot': 'Tasso/parola',
  Tadjik: 'Tajik',
  'Réf devis': 'Citazione di riferimento',
  'Rechercher un rédacteur': 'Ricerca di uno scrittore',
  Albanais: 'Albanese',
  Galicien: 'Galiziano',
  Disponibilité: 'Disponibilità',
  'Les deux mots de passe ne sonts pas identiques':
    'Le due password non sono identiche',
  Tibétain: 'Tibetano',
  'Typix - Gestion des utilisateurs': 'Typix - Gestione degli utenti',
  'Ossétien ; Ossétique': 'Osseto; Ossetico',
  Tswana: 'Tswana',
  'Ajouter un client': 'Aggiungere un cliente',
  'Séparez les mots-clés par un " Enter ".':
    'Separare le parole chiave con un "Invio".',
  'Zhuang ; Chuang': 'Zhuang; Chuang',
  Thématiques: 'Temi',
  'Nb mots/texte': 'Numero di parole/testo',
  Commerce: 'Commercio',
  'Voir les commandes': 'Vedere gli ordini',
  'Nombre de mots par texte': 'Numero di parole per testo',
  'Lien drive...': 'Unità di collegamento...',
  'Hollandais ; Flamand': 'Olandese; fiammingo',
  'Mon profil': 'Il mio profilo',
  "Ce champs doit être sup à 0 car facturation n'est pas au réel":
    'Questo campo deve essere maggiore di 0 perché la fatturazione non è reale.',
  'Le texte a été validé avec succès':
    'Il testo è stato convalidato con successo',
  Jeux: 'Giochi',
  'Voulez-vous vraiment supprimer la ligne de commande pour':
    'Si vuole davvero rimuovere la linea di comando per',
  'Ndebele, Nord ; Ndebele Nord': 'Ndebele, Nord; Ndebele Nord',
  'Slave ecclésiastique ; vieux slavon ; slavon ecclésiastique ; vieux bulgare ; vieux slavon ecclésiastique':
    'Slavo ecclesiastico; Slavo antico; Slavo ecclesiastico; Bulgaro antico; Slavo ecclesiastico antico',
  Swahili: 'Swahili',
  Voyage: 'Viaggi',
  'Nombre de mot à ajouter': 'Numero di parole da aggiungere',
  'Liste des rédacteurs': 'Elenco dei scrittori',
  'le rédacteur': "l'scrittore",
  Kanuri: 'Kanuri',
  rédacteur: 'scrittore',
  Tatar: 'Tatar',
  'Roumain ; Moldave ; Moldovan': 'Rumeno; moldavo',
  'Le texte initial de': 'Il testo originale della',
  'Mail clients': 'Posta del cliente',
  'Le contrat de': 'Il contratto di',
  'au moins une lettre minuscule et une lettre majuscule,un caractère spécial et un chiffre':
    'almeno una lettera minuscola e una maiuscola, un carattere speciale e un numero',
  Transport: 'Trasporto',
  'Nombre total de mots (existants et ajoutés) :':
    'Numero totale di parole (esistenti e aggiunte) :',
  'Rechercher par mail, prénom, nom, site...':
    'Ricerca per e-mail, nome, cognome, sito...',
  'Nombre de mot à ajouter (Min/Max) : ':
    'Numero di parole da aggiungere (Min/Max) :',
  Compte: 'Conto',
  'Tourisme/Loisirs': 'Turismo/tempo libero',
  'Nouveau texte': 'Nuovo testo',
  Max: 'Massimo',
  'Kalaallisut ; Groenlandais': 'Kalaallisut; groenlandese',
  'Oups...!il y a une/plusieurs erreur(s) dans la fenêtre du gap sémantique. Veuillez vérifier son contenu pour la/les corriger et soumettre à nouveau votre texte.':
    'Ci sono uno o più errori nella finestra del gap semantico. Si prega di controllare il contenuto per correggerlo/li e di inviare nuovamente il testo.',
  'ne peut pas être supprimé pour le moment':
    'non può essere cancellato in questo momento',
  'Le texte': 'Il testo',
  URL: 'URL',
  "Un utilisateur existe déjà avec l'email":
    "Esiste già un utente con l'e-mail",
  Cree: 'Cree',
  Prénom: 'Nome',
  'commandes prête': 'ordini pronti',
  Réinitialiser: 'Reset',
  'Veuillez fournir une date valide': 'Indicare una data valida',
  'Kuanyama ; Kwanyama': 'Kuanyama; Kwanyama',
  'Luxembourgeois ; Letzeburgesch': 'Lussemburghese; Letzeburgesch',
  Suédois: 'Svedese',
  'Confirmer le mot de passe': 'Confermare la password',
  'Ce champs est obligatoire et ne peut avoir que des nombres':
    'Questo campo è obbligatorio e può contenere solo numeri',
  Sciences: 'Scienza',
  Tchétchène: 'Ceceno',
  "est le seul client pour un site, il faut ajouter d'autres pour pouvoir le supprimer":
    "è l'unico client per un sito, è necessario aggiungerne altri per rimuoverlo.",
  'Le mot de passe de confirmation ne correspond pas':
    'La password di conferma non corrisponde',
  Swati: 'Swati',
  Danois: 'Danese',
  Sauvegarder: 'Risparmiare',
  'Veuillez changer les informations suivantes titre et/ou mot clé':
    'Modificare le seguenti informazioni: titolo e/o parola chiave',
  'importer un document': 'importare un documento',
  Maltais: 'Maltese',
  'Nb de mots': 'Numero di parole',
  'Les données fournies sont invalides': 'I dati forniti non sono validi',
  'Livraison estimée': 'Consegna stimata',
  'Grec moderne (1453-)': 'Greco moderno (1453-)',
  Avestan: 'Avestan',
  Inuktitut: 'Inuktitut',
  'Nombre total de mots ajoutés': 'Numero totale di parole aggiunte',
  'le contenu présente des inexactitudes': 'il contenuto contiene inesattezze',
  Finnois: 'Finlandese',
  'Ajouter un admin': 'Aggiungere un amministratore',
  'Min/Max': 'Min/Max',
  'Modifier le consultant': 'Modificare il consulente',
  'Liste des clients': 'Elenco dei clienti',
  'Nom client': 'Nome del cliente',
  Vert: 'Verde',
  'Mots clés manquants': 'Parole chiave mancanti',
  Lao: 'Lao',
  Somali: 'Somalo',
  'Nb de silo par texte': 'Numero di silos per testo',
  Italien: 'Italiano',
  'La commande a été mis à jour avec succès !':
    "L'ordine è stato aggiornato con successo!",
  Bosniaque: 'Bosniaco',
  'Thématiques d\u2019expertise': 'Temi di competenza',
  'Ce mot de passe est le mot de passe que vous avez oublié':
    'Questa è la password che avete dimenticato',
  'a été désactivé avec succès': 'è stato disattivato con successo',
  Kongo: 'Kongo',
  'Postuler à la commande': "Richiedere l'ordine",
  'mot-clé': 'parola chiave',
  Abkhazien: 'Abcaso',
  Mongolien: 'Mongolo',
  'Typix - Fiche site web': 'Typix - Sito web',
  'Mail envoyé': 'Posta inviata',
  Géorgien: 'Georgiano',
  'Si des phrases ne sont pas dans un français correct':
    'Se le frasi non sono in francese corretto',
  'En cours': 'In corso',
  voir: 'vedere',
  "Date d'ajout": 'Data aggiunta',
  'Tarif au mot': 'Tariffa per parola',
  Thai: 'Thailandese',
  'Détails du texte': 'Dettagli del testo',
  'Commandes en retard': 'Ordini in ritardo',
  disponible: 'disponibile',
  Droit: 'Legge',
  Azerbaïdjanais: 'Azerbaigian',
  'Ajouter un consultant': 'Aggiungere un consulente',
  'Dans le cadre d\u2019une repasse sur des contenus, seuls les éléments suivants seront pris en charge':
    'Quando si riproducono i contenuti, saranno supportati solo i seguenti elementi',
  'doit comprendre au moins 8 charactères': 'deve contenere almeno 8 caratteri',
  'Titre de la commande': "Titolo dell'ordine",
  'Langues bihari': 'Lingue bihari',
  'Livraison estimé au': 'Consegna prevista entro',
  "Le nombre de texte de la commande ne peut pas être inférieur aux nombre de textes attribuées au(x) rédacteur(s). Veuillez d'abord modifier les informations de la ligne de commande":
    "Il numero di testi nell'ordine non può essere inferiore al numero di testi assegnati agli autori. Modificare prima le informazioni nella riga di comando",
  'Date de livraison': 'Data di consegna',
  'Voulez-vous vraiment supprimer le contrat de': 'Volete davvero abolire il',
  'Facturation au réel': 'Fatturazione effettiva',
  'Gap sémantique': 'Lacuna semantica',
  Estonien: 'Estone',
  Wolof: 'Wolof',
  'Coût d\u2019achat max/mot': 'Costo massimo di acquisto/parola',
  'Détail de la commande': "Dettagli dell'ordine",
  'Export en cours de téléchargement\u2026':
    'Esportazione in corso di caricamento...',
  'Ce champ est obligatoire et doit être inférieur ou égal au Nombre total des textesde la commande':
    "Questo campo è obbligatorio e deve essere inferiore o uguale al numero totale di testi dell'ordine.",
  Arabe: 'Arabo',
  Bislama: 'Bislama',
  'Mail client': 'Posta del cliente',
  '(Titre, mot clé, url, balise, méta-description)':
    '(Titolo, parole chiave, url, tag, meta-descrizione)',
  'Typix - Nouvelle commande': 'Typix - Nuovo ordine',
  'Révision en attente': 'Recensione in corso',
  'Le consultant': 'Il consulente',
  Entreprise: 'Azienda',
  Aragonais: 'Aragonese',
  Kashmiri: 'Kashmiri',
  'a été activé': 'è stato attivato',
  'Interlingua (Association internationale des langues auxiliaires)':
    'Interlingua (Associazione internazionale delle lingue ausiliarie)',
  Actualités: 'Notizie',
  'Votre décision a été prise en compte avec succès':
    'La vostra decisione è stata presa in considerazione con successo',
  Afrikaans: 'Afrikaans',
  'contenu en attente de vérification client':
    'contenuti in attesa di verifica da parte del cliente',
  'Fiche du rédacteur': "File dell'scrittore",
  Outillage: 'Strumenti',
  'Typix - Détails de la commande': "Typix - Dettagli dell'ordine",
  'Ajouter ou compléter ci-dessous votre contenu :':
    'Aggiungete o completate il vostro contenuto qui sotto:',
  Ewe: 'Pecora',
  'contenu en attente de repasse rédacteur':
    "contenuto in attesa dell'scrittore di replay",
  'La commande a été supprimé avec succès':
    "L'ordine è stato cancellato con successo",
  'Expressions ou phrases françaises mais ne vous convenant pas':
    'Espressioni o frasi francesi che non vi si addicono',
  Corse: 'Corsica',
  Modifier: 'Modifica',
  'Nb de GMB': 'Numero di GMB',
  Oromo: 'Oromo',
  Polish: 'Polacco',
  'Insérez votre gap sémantique avec l’occurrence':
    "Inserite la vostra lacuna semantica con l'occorrenza",
  'Nb de textes à optimiser': 'Numero di testi da ottimizzare',
  Mode: 'Modalità',
  Akan: 'Akan',
  'Révisions effectués': 'Revisioni effettuate',
  'Modifier l\u2019admin': "Modificare l'amministratore",
  'Télécharger le document': 'Scarica il documento',
  Hausa: 'Hausa',
  'Notes rédacteurs': 'Note della scrittori',
  Quechua: 'Quechua',
  Féroïen: 'Faroese',
  'Modifier le rédacteur': "Cambiare l'scrittore",
  Mail: 'Posta',
  Rédacteurs: 'Scrittori',
  'Typix - Détails du texte': 'Typix - Dettagli sul testo',
  Hongrois: 'Ungherese',
  'Bon pour livraison': 'Buono per la consegna',
  'Au réel': 'Nel mondo reale',
  'Hiri Motu': 'Hiri Motu',
  Hébreu: 'Ebraico',
  'Nombre total de mots ajoutés :': 'Numero totale di parole aggiunte :',
  Komi: 'Komi',
  'Doit être inférieur au nombre maximum':
    'Deve essere inferiore al numero massimo',
  'Nom du texte': 'Nome del testo',
  'Ajouter un rédacteur': 'Aggiungere un scrittore',
  Ou: 'Oppure',
  Utilisateurs: 'Utenti',
  Heures: 'Orario',
  'Santé/Bien-être': 'Salute/Benessere',
  'Interlingue ; Occidental': 'Interlingua; occidentale',
  'Luba-Katanga': 'Luba-Katanga',
  Letton: 'Lettone',
  Anglais: 'Inglese',
  Envoyer: 'Inviare',
  'Tableau de bord': 'Cruscotto',
  'Demande de révision': 'Richiesta di revisione',
  'Résultat sémantique': 'Risultato semantico',
  'Chercher un rédacteur': 'Ricerca di un scrittore',
  'Ce champs est obligatoire': 'Questo campo è obbligatorio',
  Rédaction: 'scrittoreiale',
  'Modifier le client': 'Modificare il client',
  'Voulez-vous vraiment supprimer le rédacteur':
    "Si vuole davvero eliminare l'scrittore",
  Titre: 'Titolo',
  Langue: 'Lingua',
  'Les demandes suivantes ne seront pas prises en compte':
    'Non saranno prese in considerazione le seguenti domande',
  'délai dépassé': 'scadenza non rispettata',
  Tchouvache: 'Tchouvache',
  Ganda: 'Ganda',
  Twi: 'Twi',
  'Contrat déjà existant, veuillez modifier les informations':
    'Contratto esistente, modificare le informazioni',
  Igbo: 'Igbo',
  Yiddish: 'Yiddish',
  'Limburgan ; Limburger ; Limburgish': 'Limburghese; Limburger; Limburghese',
  'Commandes validées': 'Ordini convalidati',
  'listeRedacteur-': 'elencoRedattore-',
  Étape: 'Passo',
  'Energie/Environnement': 'Energia/Ambiente',
  Min: 'Min',
  Gujarati: 'Gujarati',
  'ne doit pas inclure votre nom/prénom':
    'non deve includere il proprio cognome/nome',
  'Typix - Fiche rédacteur': "Typix - Scheda dell'scrittore",
  'révisions effectuées en attentes de validation':
    'revisioni effettuate in attesa di convalida',
  'Textes validés': 'Testi convalidati',
  Art: 'Arte',
  Dzongkha: 'Dzongkha',
  Polyvalent: 'Versatile',
  Sundanese: 'Sundanese',
  'Nb total de textes': 'Numero totale di testi',
  'Nombre de mots gérés': 'Numero di parole gestite',
  "L'émail": 'Smalto',
  'Afficher les résultats': 'Mostra i risultati',
  'Frison occidental': 'Frisone occidentale',
  'Modification effectuée avec succès': 'Modifica completata con successo',
  'Balise titre': 'Tag del titolo',
  'Typix - Mon profil': 'Typix - Il mio profilo',
  'email invalide': 'e-mail non valida',
  'Veuillez ajouter une url afin de pouvoir sauvegarder le texte en brouillon':
    'Si prega di aggiungere un url per poter salvare il testo come bozza',
  Macédonien: 'Macedone',
  'Votre candidature a bien été envoyée': 'La vostra domanda è stata inviata',
  'E-mail': 'E-mail',
  Fulah: 'Fulah',
  'Ajouter ou compléter ci-dessous votre contenu':
    'Aggiungete o completate il vostro contenuto qui sotto',
  Manx: 'Manx',
  'Ajout de mots-clés avec la fréquence restante':
    'Aggiunta di parole chiave con frequenza residua',
  'Fiche du site web': 'Scheda del sito web',
  Contacter: 'Contatto',
  Fidjien: 'Figiana',
  Déconnexion: 'Disconnessione',
  email: 'e-mail',
  'Nombre de textes': 'Numero di testi',
  'Enregistrer et informer client': 'Registrazione e informazione dei clienti',
  'Date de validation': 'Data di convalida',
  'Tonga (Îles Tonga)': 'Tonga (Isole Tonga)',
  Javanais: 'Giavanese',
  Portugais: 'Portoghese',
  Biélorusse: 'Bielorusso',
  'Pour ajouter un nouveau texte': 'Per aggiungere un nuovo testo',
  'Enfant/Puéri': 'Bambino/Puperium',
  'Mots clés': 'Parole chiave',
  Emploi: 'Occupazione',
  'Voulez-vous vraiment supprimer la commande de':
    'Volete davvero rimuovere il',
  'Mot clé': 'Parola chiave',
  Consultants: 'Consulenti',
  Volapük: 'Volapük',
  Services: 'Servizi',
  'mot-clé (fréquence)': 'parola chiave (frequenza)',
  'Ne plus afficher ce message': 'Non visualizzare più questo messaggio',
  Consultant: 'Consulente',
  "Une erreur s'est produite": 'Si è verificato un errore',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un charactère spécial':
    'Almeno 8 caratteri con una lettera maiuscola, un numero, un carattere speciale',
  'Pushto ; Pashto': 'Pushto; Pashto',
  Français: 'Francese',
  validées: 'convalidato',
  'Url du site': 'Url del sito',
  Précédent: 'Precedente',
  'car celui-ci a déjà rédigé des textes':
    "perché quest'ultimo ha già redatto dei testi",
  'Kikuyu ; Gikuyu': 'Kikuyu; Gikuyu',
  Brouillons: 'Bozze',
  Ido: 'Ido',
  'Contenu disponible': 'Contenuto disponibile',
  Enseignement: 'Insegnamento',
  'a été livré avec succès': 'è stato consegnato con successo',
  Chinois: 'Cinese',
  Vietnamien: 'Vietnamita',
  'Nouveau client': 'Nuovo cliente',
  'Votre profil a été mis à jour avec succès.':
    'Il vostro profilo è stato aggiornato con successo.',
  Consignes: 'Istruzioni',
  'Mot de passe': 'Password',
  Annuler: 'Annullamento',
  Non: 'No',
  Nom: 'Nome',
  Guarani: 'Guarani',
  "il y'a des commandes liés à au site web":
    'ci sono ordini relativi al sito web',
  Score: 'Punteggio',
  'Mot de passe mis à jour avec succès':
    'La password è stata aggiornata con successo',
  Latin: 'Latino',
  Technologie: 'Tecnologia',
  Internet: 'Internet',
  Nauru: 'Nauru',
  'a été créé avec succès': 'è stato creato con successo',
  Roumain: 'Rumeno',
  Assamais: 'Assamese',
  'Khmer central': 'Khmer centrale',
  'Navajo ; Navaho': 'Navajo; Navaho',
  'Panjabi ; Punjabi': 'Punjabi; Punjabi',
  'Analyse/Limite': 'Analisi/Limite',
  Grec: 'Greco',
  Ojibwa: 'Ojibwa',
  'Mes Projets': 'I miei progetti',
  'keyword1 (2)\nkeyword2 (1)\nkeyword3 (1)\nkeyword4 (2)\n\u2026':
    'parola chiave1 (2)\nparola chiave2 (1)\nparola chiave3 (1)\nparola chiave4 (2)\n...',
  'ajouter un texte': 'aggiungere un testo',
  'Détail de la prestation': 'Dettagli del servizio',
  "Vous avez la possibilité d'exporter le rapport d'une, ou de plusieurs commandes. Pour exporter toutes les commandes d'un client, il vous suffit juste de cliquer sur l'icône de téléchargement en jaune":
    "È possibile esportare il report di uno o più ordini. Per esportare tutti gli ordini di un cliente, è sufficiente fare clic sull'icona gialla di download.",
  'Gestion des utilisateurs': 'Gestione degli utenti',
  'livré et inférieur au nombre de texte non affecté':
    'consegnati e inferiore al numero di testi non assegnati',
  'Date deadline validation client': 'Termine di convalida del cliente',
  Aymara: 'Aymara',
  Validées: 'Convalidato',
  Notes: 'Note',
  'Nombre de GMB': 'Numero di Ogm',
  'résultats sur': 'risultati su',
  'Prénom / Nom du client': 'Nome / Nome del cliente',
  'Tout télécharger': 'Scaricare tutti',
  'Champs obligatoires': 'Campi obbligatori',
  Éditer: 'Modifica',
  'Coller le texte initial dans le champs ci-dessous':
    'Incollare il testo originale nel campo sottostante',
  'ID rédacteur': 'ID scrittore',
  Arménien: 'Armeno',
  'Grande distribution': 'Distribuzione su larga scala',
  Welsh: 'Gallese',
  Herero: 'Herero',
  'Enrichissement sémantique': 'Arricchimento semantico',
  'Détail de la prestation du contenu': 'Dettagli sulla consegna dei contenuti',
  Noir: 'Nero',
  'Ajouter un texte': 'Aggiungere un testo',
  Traduction: 'Traduzione',
  'Immo/Defisc': 'Proprietà/Tasse',
  'Brief détaillé': 'Breve descrizione dettagliata',
  'Séparez les mots-clés par un Enter .':
    'Separate le parole chiave con un Invio .',
  Prix: 'Premi',
  'mot de passe oublié': 'Password dimenticata',
  'Ndebele, South ; South Ndebele': 'Ndebele, Sud; Ndebele meridionale',
  'Demander une révision': 'Richiedi una recensione',
  'Demander une repasse globale': 'Richiedere una revisione globale',
  'Sotho, Southern': 'Sotho, Sud',
  'Le titre de la commande existe déjà': "Il titolo dell'ordine esiste già",
  'Félicitations !': 'Congratulazioni!',
  Kurde: 'Curdo',
  Adresse: 'Indirizzo',
  Espagnol: 'Spagnolo',
  Ndonga: 'Ndonga',
  'En retard': 'In ritardo',
  'a été ajouté avec succès': 'è stato aggiunto con successo',
  Commandes: 'Ordini',
  'a été mis en brouillon': 'è stato redatto',
  'Rédacteur attribué': 'scrittore assegnato',
  Rechercher: 'Ricerca',
  'Nouvelle commande': 'Nuovo ordine',
  'Commandes non attribuées': 'Ordini non assegnati',
  'Le texte a été mis en brouillon': 'Il testo è stato redatto',
  'Contact edito': 'Contatto edito',
  Langues: 'Le lingue',
  Orange: 'Arancione',
  'Nynorsk norvégien': 'Norvegese nynorsk',
  Shona: 'Shona',
  Turkmène: 'Turcomanni',
  'contenu repassé, en attente validation client':
    'contenuto stirato, in attesa della convalida del cliente',
  'Nombre de mots rédigés': 'Numero di parole scritte',
  Malay: 'Malese',
  'Nombre de Silo': 'Numero di silo',
  Oui: 'Sì',
  Automobile: 'Automotive',
  Résultats: 'Risultati',
  Afar: 'Afar',
  'Tâche - id tâche': "Attività - id dell'attività",
  'Ce champ est obligatoire doit être supérieur à 0':
    'Questo campo è obbligatorio e deve essere maggiore di 0.',
  'Vous êtes sûr': 'È sicuro che',
  'Réinitialiser votre mot de passe': 'Reimpostare la password',
  Sindhi: 'Sindhi',
  Bengali: 'Bengalese',
  'Bokmål, norvégien ; Bokmål norvégien': 'Bokmål, norvegese; Bokmål norvegese',
  'Nombre de Jours': 'Numero di giorni',
  'Min/Max mots': 'Parole min/max',
  Slovène: 'Sloveno',
  Site: 'Sito web',
  'Sinhala ; Cingalais': 'Sinhala; singalese',
  Bulgare: 'Bulgaro',
  'Liste des commandes': 'Elenco degli ordini',
  "L'utilisateur": "L'utente",
  Uzbek: 'Uzbeko',
  'Titre du texte': 'Titolo del testo',
  Postuler: 'Candidarsi a',
  'Nb de textes par Silo': 'Numero di testi per silo',
  'Nombre total de mots (existants et ajoutés)':
    'Numero totale di parole (esistenti e aggiunte)',
  'Max.': 'Max.',
  Beauté: 'Bellezza',
  Humanitaire: 'Umanitario',
  Telugu: 'Telugu',
  'Recherche par rédacteur ou texte': 'Ricerca per autore o testo',
  'Balise meta-description': 'Tag Meta description',
  Malgache: 'Malgascio',
  Tagalog: 'Tagalog',
  'Ce champs doit être sup à 0 et inférieur à 1':
    'Questo campo deve essere maggiore di 0 e minore di 1',
  'Le rédacteur': "L'scrittore",
  'a été mis à jour avec succès': 'è stato aggiornato con successo',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un symbole et ne pas être identique au nom.':
    'Deve essere lungo almeno 8 caratteri con una lettera maiuscola, un numero, un simbolo e non identico al nome.',
  'textes en plus': 'altri testi',
  'Format souhaité': 'Formato desiderato',
  Chamorro: 'Chamorro',
  Malayalam: 'Malayalam',
  'Détail ligne de commande': "Dettaglio linea d'ordine",
  'Veuillez préciser la date': 'Specificare la data',
  Pali: 'Pali',
  Clients: 'Clienti',
  'Total facturé': 'Totale fatturato',
  'contenu validé par le client': 'contenuto convalidato dal cliente',
  'Occitan (post 1500)': 'Occitano (dopo il 1500)',
  Japonais: 'Giapponese',
  Avaric: 'Avarico',
  'Voulez-vous vraiment activer': 'Volete davvero attivare',
  Sanskrit: 'Sanscrito',
  'Toutes les notifications': 'Tutte le notifiche',
  Marathi: 'Marathi',
  Persan: 'Persiano',
  'La commande pour le client': "L'ordine per il cliente",
  'Intitulé de la commande': "Titolo dell'ordine",
  Samoan: 'Samoano',
  Autres: 'Altro',
  Sport: 'Lo sport',
  "il y'a des commandes liés au site web ":
    'ci sono ordini relativi al sito web',
  'Ajout de mots-clé avec la fréquence restante':
    'Aggiunta di parole chiave con frequenza residua',
  'a été supprimé avec succès': 'è stato rimosso con successo',
  Postulé: 'Inviato',
  Literie: 'Biancheria da letto',
  'Édité par le client': 'Modificato dal cliente',
  Cornouailles: 'Cornovaglia',
  Tigrinya: 'Tigrino',
  Textes: 'Testi',
  'Soumettre un nouveau texte': 'Invia un nuovo testo',
  Téléphone: 'Telefono',
  Deadline: 'Scadenza',
  "Une erreur s'est produite. Veuillez vérifier votre saisie ou essayer plus tard.":
    "Si è verificato un errore. Controllare l'inserimento o riprovare più tardi.",
  Marshallais: 'Marshall',
  "La demande d'ajout de crédit est envoyée":
    'La richiesta di aggiunta del credito viene inviata',
  'Le rédacteur ': "L'scrittore",
  'Demander des crédits': 'Richiesta di credito',
  "Cette commande n'existe pas": 'Questo comando non esiste',
  Inupiaq: 'Inupiaq',
  Tahitien: 'Tahitiano',
  Admins: 'Amministratori',
  'Mettez des mots-clés avec fréquence':
    'Impostare le parole chiave con frequenza',
  Notifications: 'Notifiche',
  'en retard': 'in ritardo',
  "l'admin": "l'amministratore",
  'Mail rédacteurs': 'scrittori della posta',
  Amharique: 'Amarico',
  Societe: 'Azienda',
  Tsonga: 'Tsonga',
  'Nombre de textes ajoutés': 'Numero di testi aggiunti',
  "Nombre d'agents": 'Numero di agenti',
  Société: 'Azienda',
  Yoruba: 'Yoruba',
  'Le texte a été livré avec succès':
    'Il testo è stato consegnato con successo',
  'Mettez votre texte': 'Inserite il vostro testo',
  "Oups....! Une erreur s'est produite": 'Oops....! Si è verificato un errore',
  'Prénom/Nom': 'Nome/Cognome',
  'Max doit être sup à Min': 'Max deve essere maggiore di Min',
  'Importer un autre document': 'Importare un altro documento',
  'Votre demande a expirée .. veuillez refaire une autre':
    "La sua domanda è scaduta... la preghiamo di farne un'altra.",
  'Veuillez corriger le format de votre gap sémantique afin de pouvoir sauvegarder le texte en brouillon':
    'Correggere il formato della lacuna semantica per salvare il testo come bozza.',
  Exemple: 'Esempio',
  Slovaque: 'Slovacco',
  Finance: 'Finanza',
  Réactiver: 'Riattivare',
  'Nb textes': 'Numero di testi',
  'Intitulé commande': "Titolo dell'ordine",
  Supprimer: 'Cancellare',
  Brouillon: 'Bozza',
  'Mots clés restants': 'Parole chiave rimanenti',
  Date: 'Data',
  Rôle: 'Ruolo',
  'Ce champs doit être sup à 0': 'Questo campo deve essere maggiore di 0',
  'Maison/Déco': 'Casa/Decorazione',
  'Vous avez': 'Avete',
  'Cette ligne de commande ne peut pas être supprimée car une partie de ses textes a été livré':
    'Questa riga di comando non può essere cancellata perché una parte del testo è stata consegnata',
  'vérifiez votre email et cliquez sur le lien pour continuer !':
    'controlla la tua e-mail e clicca sul link per continuare!',
  Sarde: 'Sardegna',
  'Note rédacteur': "Nota dell'scrittore",
  'Uighur ; Uyghur': 'Uighur; Uyghur',
  'Name ': 'Nome',
  'Commandes intelligentes': 'Ordini smart',
  'Commandes avec révision': 'Ordini smart + revision',
  'Type de contenu': 'Tipo di contenuto',
  'Fiche produit': 'Scheda prodotto',
  GMB: 'GMB',
  'STORE LOCATOR': 'STORE LOCATOR',
  'Rédaction premium': 'Redazione premium',
  'Rédaction avec révision': 'Redazione smart + revision',
  'Rédaction intelligente': 'Redazione smart',
  PREMIUM: 'PREMIUM',
  Type: 'Tipo',
  Editer: 'Modifica',
  'Tous les types': 'Tutti i tipi',
  Smart: 'Smart',
  'Smart + review': 'Smart + review',
  'Factures traitées': 'Fatture elaborate',
  'Factures à valider': 'Fatture da validare',
  'Impossible de générer la facture ! Veuillez réessayer':
    'Impossibile generare la fattura! Si prega di riprovare',
  'Récapitulatif de facturation': 'Riepilogo della fatturazione',
  'Demander une modification': 'Richiedi una modifica',
  'Valider et envoyer la facture': 'Convalida e invia la fattura',
  'Demande de modification': 'Richiesta di modifica',
  'La facture a été validé avec succès!':
    'La fattura è stata validata con successo!',
  "Oups un erreur c'est produit!": 'Ops, si è verificato un errore!',
  'Nombre de texte': 'Numero di testi',
  'Nombre de mot par texte :': 'Numero di parole per testo:',
  Paiement: 'Pagamento',
  Virement: 'Bonifico',
  Délai: 'Termine',
  'Référence de votre facture': 'Riferimento della tua fattura',
  'Coût au mot': 'Costo per parola',
  'Montant global de la commande': "Importo totale dell'ordine",
  'Votre facture': 'La tua fattura',
  'Importer votre facture': 'Importa la tua fattura',
  'Pas de fichier disponible': 'Nessun file disponibile',
  Télécharger: 'Scarica',
  Relancer: 'Rispedisci',
  'Générer la facture': 'Genera la fattura',
  Payée: 'Pagata',
  'En cours de paiement': 'In attesa di pagamento',
  'En cours de validation': 'In attesa di convalida',
  'A envoyer': 'Da inviare',
  'Modification demandée': 'Modifica richiesta',
  'Référence de facture est obligatoire':
    'Il riferimento della fattura è obbligatorio',
  'Le coût au mot doit être un nombre':
    'Il costo per parola deve essere un numero',
  'Le coût au mot doit être un nombre positif':
    'Il costo per parola deve essere un numero positivo',
  'Le coût au mot est obligatoire': 'Il costo per parola è obbligatorio',
  'Le montant global de la commande doit être un nombre':
    "L'importo totale dell'ordine deve essere un numero",
  'Le montant global de la commande doit être un nombre positif':
    "L'importo totale dell'ordine deve essere un numero positivo",
  'Le montant global de la commande est obligatoire':
    "L'importo totale dell'ordine è obbligatorio",
  'Bill reference existe déja , veuillez réessayer':
    'Il riferimento della fattura esiste già, si prega di riprovare',
  'La facture a été envoyée avec succès!':
    'La fattura è stata inviata con successo!',

  'Montant estimé': 'Importo stimato',
  Action: 'Azione',
  Facture: 'Fattura',
  Statut: 'Stato',
  Factures: 'Fatture',
  'Valider la facture': 'Convalida la fattura',
  'La relance a été envoyée avec succès !':
    'Il sollecito è stato inviato con successo!',
  'La demande de modification a été envoyée avec succès !':
    'La richiesta di modifica è stata inviata con successo!',
  'Le cout est trop élevé': 'Il costo è troppo alto',
  'Le montant global de la commande est trop élevé ':
    "L'importo totale dell'ordine è troppo elevato",
  jours: 'giorni',
  'Factures à envoyer': 'Fatture da inviare',
  'Valider le paiement': 'Convalida pagamento',
  'Générer une facture': 'Genera una fattura',
  'Montant rédacteur': "Importo per l'autore",
  'Montant estimé par Typix': 'Importo stimato da Typix',
  'Voir la modification': 'Visualizza modifica',

  'Tag de Titre': 'Tag del titolo',
  'Meta description': 'Meta descrizione',
  'Nom du produit': 'Nome del prodotto',
  Avantages: 'Vantaggi',
  'Description détaillée': 'Descrizione dettagliata',
  'En cours de modification': 'In fase di modifica',
  'Mes Factures': 'Le mie fatture',
  'En attente de validation': 'In attesa di convalida',
  'les valeurs négatives ne sont pas autorisées':
    'I valori negativi non sono ammessi.',
  'Texte Seulement': 'Solo testo',
  'Traduction Seulement': 'Solo traduzione',
  'La relance peut être faite 20 jours après la soumissions de la facture':
    "Il promemoria può essere inviato 20 giorni dopo l'invio della fattura",
  Instructions: 'Istruzioni',
  'Votre avis pour la commande': "Il tuo feedback per l'ordine",
  'Votre évaluation est précieuse pour nous ! Merci !':
    'La tua valutazione è preziosa per noi! Grazie!',
  "Une erreur s'est produite lors de la soumission de votre évaluation. Veuillez réessayer ultérieurement!":
    "Si è verificato un errore durante l'invio della tua valutazione. Riprova più tardi!",
  Evaluer: 'Valutare',
  Commentaire: 'Commento',
  'Votre commantaire': 'Il tuo commento',
  Note: 'Valutazione',
  'Votre retour est précieux pour nous et nous aide à améliorer nos services.':
    'Il tuo feedback è prezioso per noi e ci aiuta a migliorare i nostri servizi.',
  'Verifier la facture': 'Verifica la fattura',
  ' Votre retour est précieux pour nous et nous aide à améliorer nos services. Merci de partager votre évaluation avec nous!':
    'Il tuo feedback è prezioso per noi e ci aiuta a migliorare i nostri servizi. Grazie per aver condiviso la tua valutazione con noi!',
  'Notes rédacteur': "Note dell'autore",
  'Avis client': 'Recensioni dei clienti',
  'Pas de commantaire': 'Nessun commento',
  "Qu'avez vous pensé de votre commande?": 'Cosa ne pensi del tuo ordine?',
  'Evaluation de la commande': "Valutazione dell'ordine",
  'Rédiger un commentaire': 'Scrivi un commento',
  'Contribuez à nous permettre de vous proposer les services de rédaction de la plus haute qualité en partageant vos commentaires.':
    'Contribuisci a consentirci di offrirti servizi di redazione di altissima qualità condividendo i tuoi commenti.',
  'Que pouvons-nous améliorer?': 'Cosa possiamo migliorare?',
  Continuer: 'Continua',
  'Le dernier texte a été validé avec succès':
    "L'ultimo testo è stato convalidato con successo",
  'Rechercher par rédacteur, commandes, et montant':
    'Cerca per autore, ordini e importo',
  obligatoire: 'obbligatorio',
  'Note admin': 'Nota amministratore',
  'Note client': 'Nota cliente',
  Partie: 'Parte',
  'Vous venez de valider tous les contenus rédigés par ':
    'Hai appena convalidato tutti i contenuti scritti da ',
  "Qu'en avez vous pensé": 'Cosa ne pensi',
  'La facture a été générée avec succès !':
    'La fattura è stata generata con successo!',
  'La taille du titre et/ou la méta-description est trop courte':
    'La lunghezza del titolo e/o della meta-descrizione è troppo breve',

  'Demande de révision globale': 'Richiedere una revisione globale',
  Valider: 'Convalidare',
  'Obligatoire en cas d’optimisation ou traduction':
    'Obbligatorio in caso di ottimizzazione o traduzione',
  'Mots clés Bourrées': 'Keyword stuffing',
  'Votre commentaire...': 'Il tuo commento...',
  'Ex : "Contenus de très bonne qualité':
    'Esempio: "Contenuti di ottima qualità"',
  "pouvez-vous s'il vous plaît reprendre ce/tte rédacteur/rice pour les prochaines commandes?":
    'Potresti per favore assegnare questo scrittore per gli ordini futuri?',
  'Ce bouton est pour informer le client que le texte initial, contenait déjà du keyword stuffing':
    'Questo pulsante serve a informare il cliente che il testo originale conteneva già un eccesso di parole chiave',
  'Maillage Interne': 'Internal link',
  'Modifier le texte': 'Modifica il testo',
  Ajouter: 'Aggiungi',
  'Demande examen': 'Richiesta di esame',
  'Recherche de mots clés à haute densité': 'Ricerca di keyword stuffing',
  'Oups, il semblerait qu’il y ait du keyword stuffing dans votre texte : ':
    'Ops, sembra che ci sia un keyword stuffing nel tuo testo: ',
  'Oups, il semblerait qu’il y ait du keyword stuffing (trop d’occurrences d’un ou plusieurs mots clés) dans le texte initial.':
    'Ops, sembra che ci sia keyword stuffing (troppo numero di occorrenze di una o più parole chiave) nel testo originale.',
  'Merci de vous assurer que la densité des mots clés soit optimisée pour le SEO (une occurrence maximum tous les 50 mots).':
    "Per favore assicuratevi che la densità delle parole chiave sia ottimizzata per l'SEO (un massimo di una occorrenza ogni 50 parole).",
  'Pour cela merci de ne pas retoucher le texte existant et de bien vouloir envoyer une demande d’examen au support.':
    'Per questo, per favore non modificare il testo esistente e gentilmente inviare una richiesta di esame al supporto.',
  'Votre demande a été bien envoyée !':
    'La tua richiesta è stata inviata con successo!',
  "Il y a eu un problème lors de l'envoi de votre demande":
    "Si è verificato un problema durante l'invio della tua richiesta.",
  'Veuillez attendez pour le  keyword Stuffing analyse':
    "Attendere per l'analisi del keyword stuffing.",
  'Inserez le maillage interne': 'Inserisci la rete interna',
  'Merci de vous assurer que la densité des mots clés soit optimisée pour le SEO (une occurrence maximum tous les 50 mots).\nSi vous constatez un terme pouvant avoir plusieurs significations (Exemple : Former / Formation/ Forme ou Matelas/Matelassé) , vous pouvez faire une demande d’examen auprès du support.':
    "Assicurati che la densità delle parole chiave sia ottimizzata per l'ottimizzazione sui motori di ricerca (massimo una occorrenza ogni 50 parole).\nSe incontri una parola che può avere più significati (Esempio: Former / Formation / Form o Matelas / Matelassé), puoi richiedere una revisione al supporto.",
  'Mots clés à haute densité dans le texte actuel':
    'Trefwoorden met hoge dichtheid in de huidige tekst',
  'Mots clés à haute densité dans le texte initial':
    'Trefwoorden met hoge dichtheid in de oorspronkelijke tekst',
  'Texte en cours de rédaction !': 'Testo in fase di redazione !',
  'Êtes-vous sûr(e) de vouloir valider le texte ? Assurez-vous d’abord d’avoir enregistré les modifications.':
    'Sei sicuro/a di voler confermare il testo? Assicurati prima di aver salvato le modifiche.',
  "Information dernière minute ! Ton stock de crédits sera bientôt épuisé :( Pour anticiper, n'hésite pas à demander dès maintenant plus de crédits pour terminer ta commande.":
    "Informazione dell'ultimo minuto! Il tuo saldo di crediti sarà presto esaurito :( Per anticipare, non esitare a richiedere più crediti ora per completare il tuo ordine.",
  'Voulez-vous confirmer l’URL actuelle ou la modifier ?':
    "Vuoi confermare l'URL attuale o modificarlo?",
  'Veuillez fournir une URL valide': 'Si prega di fornire un URL valido.',
  'Merci de bien vouloir indiquer ci-dessous l’url de la page où a été intégré le contenu:':
    "Per favore, indica gentilmente l'URL della pagina dove è stato integrato il contenuto di seguito:",
  'Contenu en ligne': 'Contenuto online',
  'Télécharger le document de révision': 'Scarica il documento di revisione',
  'Date d’envoi': 'Data di invio',
  Information: 'Informazione',
  Enregistrer: 'Salva',
  'Textes en ligne': 'Testi online',
  'Livrer les textes': 'Consegnare i testi',
  Indisponible: 'Non disponibile',
  Disponible: 'Disponibile',
  'Les textes ont été livrés avec succès.':
    'I testi sono stati consegnati con successo.',
  'Le texte a été livré avec succès.':
    'Il testo è stato consegnato con successo.',
  'Les textes ont été validés avec succès.':
    'I testi sono stati convalidati con successo.',
  'Le texte a été validé avec succès.':
    'Il testo è stato convalidato con successo.',
  'Voulez-vous vraiment valider les Textes de la commande':
    'Vuoi davvero convalidare i testi dell ordine?',
  'Voulez-vous vraiment livrer les Textes de la commande':
    'Vuoi davvero consegnare i testi dell ordine?',
  'Fiche produit longue': 'Scheda prodotto lunga',
  'Fiche produit courte': 'Scheda prodotto corta',
  'Un texte est trop long et ne peut pas être exporté sur Excel':
    'Un testo è troppo lungo e non può essere esportato su Excel.',
  'Mettre un texte en brouillon en livré':
    'Cambia un testo da bozza a consegnato',
  'Remettre un texte validé à livré':
    'Een gevalideerde tekst naar geleverd veranderen',
  'Invalider le texte': 'Invalidare il testo',
  'Je souhaiterai modifier mon mot de passe : comment faire ?':
    'Vorrei cambiare la mia password: come faccio?',
  'Comment mettre un contenu en bon pour livraison ?':
    'Come impostare il contenuto pronto per la consegna?',
  'Je ne peux pas mettre mon contenu en « brouillon »':
    'Non posso salvare il mio contenuto come "bozza"',
  'Typix n’a pas enregistré mes dernières modifications':
    'Typix non ha salvato le mie ultime modifiche',
  'Comment rédiger une création de contenu ?':
    'Come scrivere una creazione di contenuti?',
  'Comment rédiger une optimisation de contenu ?':
    'Come scrivere un ottimizzazione dei contenuti?',
  'Je ne vois plus ma commande – que faire ?':
    'Non vedo più il mio ordine – cosa fare?',
  'Comment générer une facture ?': 'Come generare una fattura?',
  'Je ne peux pas generer ma facture : que faire ?':
    'Non posso generare la mia fattura: cosa fare?',
  'Tuto process Typix global': 'Processo globale Typix - tutorial',
  'Tuto mise en ligne des contenus': 'Come caricare contenuti - tutorial',
  'Modification mot de passe': 'Modifica della password',
  'Le test ne me convient pas': 'Il test non mi va bene',
  'Comment valider un contenu dans Typix ?':
    'Come validare i contenuti in Typix?',
  'Tuto Facturation': 'Tutorial di fatturazione',
  'Le statut du contenu a bien été modifié':
    'Lo stato del contenuto è stato modificato con successo',
  'Le gap sémantique de ce mot clé n’a pas encore été validé, veuillez contacter le support Typix : support-typix@pixalione.com':
    'Il divario semantico di questa parola chiave non è ancora stato convalidato, contatta il supporto Typix: support-typix@pixalione.com',
  'Ce mot clé n’existe pas sur MONETORING, veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'Questa parola chiave non esiste su MONETORING, verifica con il supporto Typix: support-typix@pixalione.com',
  'Récupérer le Gap': 'Recuperare il divario',
  'Le statut du contenu a bien été modifié':
    'Lo stato del contenuto è stato modificato con successo',
  'Le gap sémantique de ce mot clé n’a pas encore été validé, veuillez contacter le support Typix : support-typix@pixalione.com':
    'Il divario semantico di questa parola chiave non è ancora stato convalidato, contatta il supporto Typix: support-typix@pixalione.com',
  'Ce mot clé n’existe pas sur MONETORING, veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'Questa parola chiave non esiste su MONETORING, verifica con il supporto Typix: support-typix@pixalione.com',
  'Récupérer le Gap': 'Recuperare il divario',
  'Traduction premium': 'Traduzione premium',
  'Rédaction et/ou Traduction intelligente':
    'Scrittura e/o Traduzione intelligente',
  'Rédaction et/ou Traduction premium': 'Scrittura e/o Traduzione premium',
  'Rédaction et/ou Traduction avec révision':
    'Scrittura e/o Traduzione con revisione',
  'Rédaction et/ou Traduction intelligente':
    'Scrittura e/o Traduzione intelligente',
  'Traduction avec révision': 'Traduzione con revisione',
  'Traduction intelligente': 'Traduzione intelligente',
  'Le nombre de mots commandé est supérieur à celui vendu':
    'Il numero di parole ordinate è superiore a quelle vendute',
  'Rédaction et/ou Traduction premium': 'Scrittura e/o traduzione premium',
  'Rédaction et/ou Traduction smart + review':
    'Scrittura e/o traduzione intelligente + revisione',
  'Rédaction et/ou Traduction smart': 'Scrittura e/o traduzione intelligente',
  'Nom Silo': 'Nome Silo',
  'Remettre en brouillon': 'Riporta a bozza',
  'Bon pour Livraison Vérifié': 'Verificato per consegna',
  'Voulez-vous vraiment remettre en brouillon les Textes de la commande':
    'Sei sicuro di voler riportare i testi dell’ordine a bozza',
  'La vérification du texte a été annulée.':
    'La verifica del testo è stata annullata.',
  'Voulez-vous vraiment annuler la vérification du texte?':
    'Vuoi davvero annullare la verifica del testo?',
  'Etes-vous sûr(e) de vouloir regénérer tous les contenus ?':
    'Sei sicuro/a di voler rigenerare tutti i contenuti?',
  'Je suis sûr(e)': 'Sono sicuro/a',
  'Non, revenir en arrière': 'No, torna indietro',
  'à cocher si la commande a l’intention d’avoir un rédacteur exclusif pour le client':
    'selezionare se l’ordine intende avere un redattore esclusivo per il cliente',
  Gouvernance: 'Governance',
  'Modification à valider': 'Modifica da convalidare',
  Rédacteur: 'Redattore',
  'Nouveau site web': 'Nuovo sito web',
  'Mail Chef Project': 'Email del project manager',
  'Site web': 'Sito web',
  'Liste des siteweb': 'Elenco dei siti web',
  'Projets non attribuées': 'Progetti non assegnati',
  'Projets en cours': 'Progetti in corso',
  'Projets en retard': 'Progetti in ritardo',
  'Projets validées': 'Progetti validati',
  'Projets smart + reviews': 'Progetti smart + reviews',
  'Projets smart': 'Progetti smart',
  'Ajouter un siteweb': 'Aggiungi un sito web',
  'Nouveau projet': 'Nuovo progetto',
  'Comparaison du score global': 'Comparison of global score',
  'avec le top 3 concurrents': 'with top 3 competitors',
  'Position du mot clé avec le top 3 concurrents': 'Keyword ranking',
  Balises: 'Tag',
  Lisibilité: 'Leggibilità',
  'Longueur des paragraphes': 'Lunghezza dei paragrafi',
  Phrases: 'Frasi',
  'de +100 mots sur': 'più di +100 parole in',
  Phrase: 'Frase',
  'de +20 mots sur': 'più di +20 parole in',
  'Notre recommandation': 'La nostra raccomandazione',
  'Longueur du texte': 'Lunghezza del testo',
  'Formats de contenus variés': 'Formati di contenuto vari',
  'par rapport au top 3 de vos concurrents':
    'rispetto al top 3 dei tuoi concorrenti',
  'Vous êtes': 'Sei',
  'Vous avez un score global de': 'Hai un punteggio globale di',
  'pour une moyenne du secteur à': 'per una media del settore di',
  'GAP comblé - Mission accomplie': 'Gap colmato – Missione completata',
  'Mots clé restants': 'Parole chiave rimanenti',
  'Phrases de +20 mots': 'Frasi con più di 20 parole',
  'Titre H1': 'Titolo H1',
  'Titres H2': 'Titoli H2',
  'Dans le texte actuel': 'Nel testo attuale',
  'Dans le texte initial': 'Nel testo iniziale',
  mots: 'parole',
  objectif: 'obiettivo',
  phrase: 'frase',
  paragraphe: 'paragrafo',
  'Temps de lecture': 'Tempo di lettura',
  'requis ( Bullet point, Bon à savoir,Sommaire)':
    'richiesto (punti elenco, da sapere, sommario)',
  'de contenu sur': 'quantità di contenuto in',
  'Félicitations ! Le nombre de mots correspond à la quantité d’informations importantes permettant de répondre au sujet':
    'Congratulazioni! Il numero di parole corrisponde alla quantità di informazioni necessarie per rispondere all’argomento.',
  'Félicitations ! Votre contenu ne contient aucune phrase de plus de 20 mots !':
    'Congratulazioni! Il tuo contenuto non contiene frasi con più di 20 parole!',
  'Félicitations ! Votre contenu est aéré et facilite la lecture':
    'Congratulazioni! Il tuo contenuto è ben strutturato e facilita la lettura.',
  'Félicitations ! Votre contenu dispose de formats variés qui dynamisent la lecture et permettent d’isoler les informations importantes.':
    'Congratulazioni! Il tuo contenuto utilizza formati vari che rendono la lettura più dinamica e evidenziano le informazioni importanti.',
  'Félicitations ! Le contenu présente une balise h1 unique et contient le mot clé à l’origine du texte':
    'Congratulazioni! Il contenuto ha un’unica etichetta H1 e include la parola chiave principale.',
  'Félicitations ! Le contenu est structuré de façon cohérente et présente au moins 2 balises <h2>':
    'Congratulazioni! Il contenuto è strutturato in modo coerente e presenta almeno due etichette <h2>.',
  'Félicitations ! Votre contenu contient du maillage interne pondéré et qui ne pollue pas la lecture.':
    'Congratulazioni! Il tuo contenuto contiene link interni bilanciati che non disturbano la lettura.',
  'Félicitations ! Le scoring d’enrichissement est supérieur à 85%!':
    'Congratulazioni! Il punteggio di arricchimento supera l’85%!',
  'Félicitations ! Votre texte n’est pas suroptimisé sur le mot clé ciblé.':
    'Congratulazioni! Il tuo testo non è sovraottimizzato per la parola chiave scelta.',
  'Le nombre de mots doit correspondre à la quantité d’informations importantes permettant de répondre au sujet':
    'Il numero di parole deve corrispondere alla quantità di informazioni necessarie per rispondere all’argomento.',
  'Il est important d’adapter le niveau de vocabulaire en fonction de votre cible. Un vocabulaire simple pourrait l’infantiliser et, à l’inverse, un vocabulaire trop complexe pourrait rendre le contenu inaccessible.':
    'È importante adattare il livello di vocabolario al pubblico. Un vocabolario troppo semplice può infantilizzare, uno troppo complesso può rendere il contenuto inaccessibile.',
  'Plus de 70% des internautes ne lisent pas les phrases > 20 mots => Utiliser des phrases concises pour augmenter le temps de rétention sur la page':
    'Oltre il 70% degli utenti non legge frasi con più di 20 parole → usa frasi concise per aumentare il tempo di permanenza sulla pagina.',
  "Un contenu constitué de blocs de paragraphes trop compact va altérer l'UX et augmenter le taux de rebond.":
    'Un contenuto con paragrafi troppo compatti compromette l’esperienza utente e aumenta il tasso di rimbalzo.',
  "Multipliez les différents formats d'affichage pour une lecture plus lisible et confortable.":
    'Varia i formati di presentazione per una lettura più chiara e confortevole.',
  'Un contenu optimisé doit obligatoirement contenir une seule balise h1 et mentionner le mot clé. ':
    'Un contenuto ottimizzato deve contenere un’unica etichetta H1 e menzionare la parola chiave.',
  'Pour une structure de contenu optimale, il faut au moins 2 balises h2.':
    'Per una struttura ottimale, sono necessarie almeno due etichette H2.',
  'Le maillage interne est un très bon moyen de connecter une page avec d’autres pages traitant du même sujet, ou complémentaires.':
    'Il linking interno è un ottimo modo per collegare una pagina ad altre pagine pertinenti o complementari.',
  'Un contenu optimisé doit obtenir un scoring d’enrichissement de min 85%. Supprimer du gap sémantique altèrera le scoring d’optimisation':
    'Un contenuto ottimizzato dovrebbe ottenere un punteggio di arricchimento minimo dell’85%. Rimuovere contenuti semantici riduce il punteggio.',
  'Répéter le mot trop de fois dans le contenu est pénalisant pour le moteur de recherche. Idéalement, ne pas dépasser un taux de 2.35% (soit environs 2 répétitions pour 100 mots). ':
    'Ripetere troppo la parola chiave penalizza i motori di ricerca. Idealmente non superare il 2,35% (circa 2 ripetizioni ogni 100 parole).',
  'Aucune balise H1 trouvée.': 'Nessuna etichetta H1 trovata.',
  'Balise H1 contient le mot-clé.': 'L’etichetta H1 contiene la parola chiave.',
  'Balise H1 présente mais sans le mot-clé.':
    'L’etichetta H1 è presente ma non contiene la parola chiave.',
  '{{count_total}} balises H2 trouvées, {{count_with_kw}} avec mot-clé.':
    '{{count_total}} etichette H2 trovate, {{count_with_kw}} con parola chiave.',
  ' balises H2 trouvées,': ' etichette H2 trovate,',
  ' avec mot-clé.': ' con parola chiave.',
  'Très facile à lire : Accessible aux enfants ou à des personnes avec un niveau de lecture basique.':
    'Molto facile da leggere: accessibile a bambini o persone con competenze di lettura di base.',
  'Facile à lire : Compréhensible par la majorité des adultes et adolescents.':
    'Facile da leggere: comprensibile per la maggior parte di adulti e adolescenti.',
  'Difficile à lire : Nécessite un bon niveau de lecture, parfois un bagage académique':
    'Difficile da leggere: richiede buon livello di lettura, a volte background accademico.',
  'Très difficile à lire : Réservé à un public expert ou très averti':
    'Molto difficile da leggere: riservato a lettori esperti o molto preparati.',
  'Wording adapté': 'Scelta di parole adatta',
  "La balise H1 est essentielle pour l'optimisation SEO.":
    'L’etichetta H1 è essenziale per l’ottimizzazione SEO.',
  'Une seule balise H1 avec le mot-clé est recommandée.':
    'Si raccomanda una sola etichetta H1 con la parola chiave.',
  'Ajoutez le mot-clé dans la balise H1.':
    'Aggiungi la parola chiave nell’etichetta H1.',
  'Adaptez votre vocabulaire à votre audience. Trop simple infantilise, trop complexe exclut.':
    'Adatta il vocabolario al tuo pubblico. Troppo semplice infantilizza, troppo complesso esclude.',
  'Les contenus web se lisent rapidement. Un temps trop long peut décourager.':
    'I contenuti web si leggono rapidamente. Un tempo troppo lungo può scoraggiare.',
  'Information sur la structure': 'Informazioni sulla struttura',
  'Information sur le résultat sémantique': 'Informazioni sul risultato semantico',
  'Information sur les balises HTML': 'Informazioni sui tag HTML',
  'Information sur le keyword stuffing': 'Informazioni sul keyword stuffing',
  ////////
  'Derniers contenus rédigés': 'Ultimi contenuti scritti',
  'voir plus': 'Vedi di più',
  'texte': 'Testo',
  'date d\'ajout': 'Data di aggiunta',
  'titre du projet': 'Titolo del progetto',
  'Date de création': 'Data di creazione',
  'dernières projets créés': 'Ultimi progetti creati',
  '% projets par statut de validation :': '% progetti per stato di validazione:',
  'non attribués': 'Non assegnati',
  'en cours': 'In corso',
  'en retard': 'In ritardo',
  'validées': 'Validati',
  'smart + reviews': 'Smart + Recensioni',
  'smart': 'Smart',
  'premium': 'Premium',
  'smart + review': 'Smart + Revisione',
  'Statut d\'avancement des contenus:': 'Stato di avanzamento dei contenuti:',
  'Nombre de textes publiés :': 'Numero di testi pubblicati:',
  'Nb de textes publiés': 'Num. testi pubblicati',
  'Top ranked': 'Top classificati',
  'Mot clé': 'Parola chiave',
  'Clicks': 'Click',
  'Clicks (Y-1)': 'Click (Y-1)',
  'Position': 'Posizione',
  'Sessions': 'Sessioni',
  'Sessions (Y-1)': 'Sessioni (Y-1)',
  'Evolution performance': 'Evoluzione delle performance',
  'Pourcentage': 'Percentuale',
  'Livré': 'Consegnato',
  'Publié': 'Pubblicato',
  'Suivez vos contenus et projets en temps réel': 'Segui i tuoi contenuti e progetti in tempo reale',
  'Tableau de bord': 'Cruscotto',
  'Titre du projet': 'Titolo del progetto',
  'Conversions': 'Conversioni',
  'Impressions': 'Impression',
  'Jan': 'Gen',
  'Fév': 'Feb',
  'Mars': 'Mar',
  'Avr': 'Apr',
  'Mai': 'Mag',
  'Juin': 'Giu',
  'Juil.': 'Lug',
  'Août': 'Ago',
  'Sept': 'Set',
  'Oct': 'Ott',
  'Nov': 'Nov',
  'Déc': 'Dic',
  'Pour activer cette fonctionnalité, ajoutez notre adresse ': 'Per attivare questa funzione, aggiungi il nostro indirizzo ',
  'à votre ': ' al tuo ',
  'Search Console': 'Search Console',
  ', ': ', ',
  'puis cliquez ici pour lancer l’analyse.': 'poi clicca qui per avviare l’analisi.',
  'all devices': 'tutti i dispositivi',
  'Desktop': 'Desktop',
  'Mobile': 'Mobile',
  '30 days': '30 giorni',
  '7 days': '7 giorni',
  '90 days': '90 giorni',
  'Aucun projet créé pour le moment.': 'Nessun progetto creato al momento.',
  'Lancer votre premier projet': 'Avvia il tuo primo progetto',
  'Aucun contenu disponible pour ce site web.': 'Nessun contenuto disponibile per questo sito web.',
  'Mes contenus': 'I miei contenuti',
  'Type de contenu': 'Tipo di contenuto',
  'Date d\'ajout': 'Data di aggiunta',
  'URL': 'URL',
  'Status': 'Stato',
  'Date de livraison': 'Data di consegna',
  'Date de validation': 'Data di validazione',
  'Date de déploiement': 'Data di implementazione',
  'Action': 'Azione',
  'Aucun contenu pour ce filtre.': 'Nessun contenuto per questo filtro.',
  'Chargement...': 'Caricamento...',
  'Aucun contenu.': 'Nessun contenuto.',
  'Précédent': 'Precedente',
  'Suivant': 'Successivo',
  'fiche produit': 'Scheda prodotto',
  'Page catégorie': 'Pagina categoria',
  'Fiche GMB': 'Scheda GMB',
  'store locator': 'Localizzatore negozi',
  'redaction': 'Redazione',
  'traduction': 'Traduzione',
  'Fiches produit SEO': 'Schede prodotto SEO',
  'Derniers projets crées': 'Ultimi progetti creati',
  'Agent IA': 'Agente AI',
  'Dérniére mise à jour': 'Ultimo aggiornamento',
  'Créer un nouveau contenu': 'Crea nuovo contenuto',
  'Rédigez un texte optimisé grâce à l’IA — rapide, pertinent et performant.': 'Scrivi un testo ottimizzato dall’IA – rapido, pertinente ed efficace.',
  'Validé': 'Validato',
  'En ligne': 'Online',
  'Fiches GMB': 'Schede GMB',
  'Fiches store locator': 'Schede localizzatore negozi',
  'Pages catégories': 'Pagine categoria',
  'Traduction IA': 'Traduzione AI',
  'Actions': 'Azioni',
  'Traduire un nouveau contenu': 'Traduci nuovo contenuto',
  'Traduisez vos contenus automatiquement avec une précision multilingue.': 'Traduci automaticamente i tuoi contenuti con precisione multilingue.',
  'Nom du projet': 'Nome del progetto',
  'Chef de projet': 'Project manager',
  'Deadline du projet': 'Scadenza del progetto',
  'Informations globales': 'Informazioni generali',
  'Contenu du projet': 'Contenuto del progetto',
  'Séléctionner le type de contenu': 'Seleziona il tipo di contenuto',
  'Sélectionner un agent IA personnalisé': 'Seleziona un agente AI personalizzato',
  'Créer un agent IA personnalisé': 'Crea un agente AI personalizzato',
  'Liens utiles': 'Link utili',
  'Rédacteur(s)': 'Redattore(i)',
  'Deadline': 'Scadenza',
  'Nb textes': 'Num. testi',
  'IA + Revue par rédacteur': 'AI + Revisione redattore',
  'Ajouter un projet': 'Aggiungi progetto',
  'Projets': 'Progetti',
  'Non attribués': 'Non assegnati',
  'Rédaction IA': 'Redazione AI',
  'Résultats sur': 'Risultati su',
  'Êtes-vous sûr de vouloir supprimer cet agent IA ?': 'Sei sicuro di voler eliminare questo agente AI?',
  'Mes agents IA': 'I miei agenti AI',
  'Tous': 'Tutti',
  'Rédaction': 'Redazione',
  'Traduction': 'Traduzione',
  'Rechercher': 'Cerca',
  'Sélectionner un site': 'Seleziona sito',
  'Créer un agent IA personnalisé': 'Crea un agente AI personalizzato',
  'Définissez la mission, le rôle, la langue, le type de contenu et plus encore.': 'Definisci missione, ruolo, lingua, tipo di contenuto e altro.',
  'Nouvel agent': 'Nuovo agente',
  'Rôle :': 'Ruolo:',
  'Type de contenu :': 'Tipo di contenuto:',
  'Langue :': 'Lingua:',
  'Siteweb :': 'Sito web:',
  'GBP': 'GBP',
  'Sélectionner un LLM': 'Seleziona LLM',
  'Fiche produit smart': 'Scheda prodotto smart',
  'Détails du texte': 'Dettagli del testo',
  '(Mot clé*, URL, Balise titre, Balise méta-description)': '(Parola chiave*, URL, Tag titolo, Meta-descrizione)',
  'URL siteweb*': 'URL sito web*',
  'Balise titre': 'Tag titolo',
  'Balise méta-description': 'Meta-descrizione',
  'Sélectionner un site web': 'Seleziona sito web',
  'Sélectionner un agent IA': 'Seleziona agente AI',
  'Lancer': 'Avvia',
  'Relancer': 'Riavvia',
  'Génération en cours...': 'Generazione in corso...',
  'Générer': 'Genera',
  'Enregistrement...': 'Salvataggio...',
  'Enregistrer ': 'Salva',
  'Livrer': 'Consegna',
  'Livraison...': 'In consegna...',
  'En ligne...': 'Online...',
  "Derniers contenus ajoutés": "Contenuti più recenti",
  ////


  'Nom de l\'agent': 'Nome dell\'agente',
  'Site web': 'Sito web',
  'Mission': 'Missione',
  'Langue de traduction': 'Lingua di traduzione',
  'Langue': 'Lingua',
  'Tonalité': 'Tono',
  'Cible / Audience': 'Pubblico target',
  'Base de connaissance locale': 'Base di conoscenza locale',
  'Base de connaissance en ligne': 'Base di conoscenza online',
  'Sélect. fichiers': 'Seleziona file',
  'Ex: URL1, URL2': 'Es.: URL1, URL2',
  'Annuler': 'Annulla',
  'Mettre à jour': 'Aggiorna',
  'Valider': 'Convalida',
  'Ex: un paragraphe sur les types d\'intervention, un paragraphe sur les avantages':
    'Es.: un paragrafo sui tipi di intervento, un paragrafo sui vantaggi',
  'ex : les parapluies pliant sont à ouverture automatique, les autres sont manuels':
    'Es.: gli ombrelli pieghevoli si aprono automaticamente, gli altri sono manuali',
  '📚 Base de connaissances': '📚 Base di conoscenza',

  'Type de produits / services proposés par le site*': 'Tipo di prodotti/servizi offerti dal sito*',
  'Règles rédactionnelles': 'Regole redazionali',
  'Lexique recommandé': 'Lessico consigliato',
  'Expressions interdites': 'Espressioni vietate',
  'Instructions de personnalisation': 'Istruzioni di personalizzazione',

  "🧩 Informations générales": "🧩 Informazioni generali",
  "🗣️ Ton & Audience": "🗣️ Tono e pubblico",
  "📝 Structure & Rédaction": "📝 Struttura e redazione",
  "📚 Base de connaissances": "📚 Base di conoscenza",
  "Structure de texte attendu": "Struttura del testo prevista",
  "Enrichissement SEO": "Ottimizzazione SEO",
  "traduction IA": "Traduzione AI",
  "Traduction en cours...": "Traduzione in corso...",
  "Traduire": "Traduci",
  "Créer votre assistant éditorial sur mesure": "Crea il tuo assistente editoriale personalizzato",
  "Votre texte traduit": "Il tuo testo tradotto",
  "Détail du projet": "Dettagli del progetto",
  "Détail d'attribution": "Dettagli di attribuzione",
  "Détail des contenus": "Dettagli dei contenuti",

  "Nom agent": "Nome agente",
  "Rédaction": "Redazione",
  "Traduction": "Traduzione",
  "Mots clé": "Parole chiave",
  "Url de la page": "URL della pagina",
  "Entrez le mot clé principal": "Inserisci la parola chiave principale",
  "Entrez l url": "Inserisci l'URL",
  "Date d'ajout": "Data di aggiunta",
  "Dernière mise à jour": "Ultimo aggiornamento",
  "URL": "URL",
  "Status": "Stato",
  "Actions": "Azioni",
  "Détails du texte": "Dettagli del testo",
  "Contenus disponibles": "Contenuti disponibili",
  "Textes générés": "Testi generati",

  "Veuillez d'abord sélectionner un site web": "Seleziona prima un sito web",
  "Chargement des agents...": "Caricamento degli agenti...",
  "Aucun agent disponible pour ce site": "Nessun agente disponibile per questo sito",
  "Sélectionner...": "Seleziona...",
  "Modifier cet agent": "Modifica questo agente",
  "Créer un agent IA personnalisé": "Crea un agente IA personalizzato",
  "Rédaction en cours...": "Redazione in corso...",
  "Génération en cours": "Generazione in corso",
  "Rédiger un contenu": "Scrivi un contenuto",
  "Rédiger un lot de contenus": "Scrivi un lotto di contenuti",
  "Url page": "URL pagina",
  "Entrez l'URL cible de votre contenu (facultatif).": "Inserisci l'URL di destinazione del tuo contenuto (facoltativo).",
  "GAP sémantique": "GAP semantico",
  "keyword1 (2),\nkeyword2 (1),\nkeyword3 (1),\nkeyword4 (2),\n.....":
    "keyword1 (2),\nkeyword2 (1),\nkeyword3 (1),\nkeyword4 (2),\n.....",
  "Maillage interne": "Link interni",
  "Introduisez le maillage": "Inserisci i link",
  "Introduisez le maillage interne": "Inserisci i link interni",
  "Importer un fichier contenant la liste des thématiques à rédiger et l'IA fera le reste 😊":
    "Importa un file contenente l'elenco degli argomenti da scrivere e l'IA farà il resto 😊",
  "Importer": "Importa",
  "Saisissez le mot-clé principal de votre contenu.": "Inserisci la parola chiave principale del tuo contenuto.",
  "Texte à traduire": "Testo da tradurre",
  "Saisissez le texte à traduire": "Inserisci il testo da tradurre",
  "Traduire un contenu": "Traduci un contenuto",
  "Traduire un lot de contenus": "Traduci un lotto di contenuti",
  "Importer un fichier contenant la liste des textes à traduire et l'IA fera le reste 😊":
    "Importa un file contenente l'elenco dei testi da tradurre e l'IA farà il resto 😊",
  "Commencer la traduction": "Inizia la traduzione",
  "Lancer la traduction": "Avvia la traduzione",
  "Commencer la rédaction": "Inizia la redazione",
  "Lancer la rédaction": "Avvia la redazione",

  'En ligne...': 'In linea...',
  'Ajouter un nouveau site web': 'Aggiungi un nuovo sito web',
  'Créer': 'Crea',
  'Séléctionner ou ajoutez les thématiques qui reflètent votre expertise.': 'Seleziona o aggiungi le tematiche che riflettono la tua esperienza.',
  'Ajoutez ou sélectionnez une thématique': 'Aggiungi o seleziona una tematica.',
  'Le site web a été créé avec succès': 'Il sito web è stato creato con successo',
  'Nous configurons actuellement vos agents IA. Ils seront bientôt prêts à vous assister dans la génération de vos contenus.': 'Stiamo configurando i tuoi agenti IA. Saranno presto pronti ad assisterti nella generazione dei tuoi contenuti.',
  'Derniers contenus ajoutés': 'Ultimi contenuti aggiunti',
  'Tous les sites': 'Tutti i siti',
  'Sélectionner le site web': 'Seleziona il sito web',
  'Aucun fichier sélectionné': 'Nessun file selezionato',
  'ex : utilise le vouvoiement, utilise un vocabulaire compréhensible par la cible': 'Es.: usa il tono formale e un vocabolario comprensibile al pubblico di destinazione.',
  '🧠 Créer un agent IA': '🧠 Crea un agente IA',
  '🧠 Modifier un agent IA': '🧠 Modifica un agente IA',
  'Ex : AMF (Autorité des Marchés Financiers).': 'Es.: AMF (Autorità dei Mercati Finanziari).',
  'Ex: bio, écologique, nom des concurrents': 'Es.: biologico, ecologico, nomi dei concorrenti.',
  'Détailler le plus possible la structure attendue à l\'aide d\'axes de rédaction pour guider l\'IA sur les sujets à traiter et dans quel ordre': 'Dettaglia il più possibile la struttura attesa per guidare l’IA sugli argomenti da trattare e nel loro ordine.',
  'Ajouter des éléments que l\'IA doit ou ne pas faire ou mentionner': 'Aggiungi elementi che l’IA deve o non deve fare o menzionare.',
  'Ex: prêt-à-porter féminin': 'Es.: prêt-à-porter femminile',
  'Ex: Rédacteur SEO': 'Es.: redattore SEO',
  'Indiquer la liste des urls sur lesquels l\'IA peut s’appuyer': 'Indica l’elenco degli URL su cui l’IA può basarsi.',
  'Créez, optimisez, performez : votre contenu prend une nouvelle dimension.': 'Crea, ottimizza, migliora: il tuo contenuto prende una nuova dimensione.',
  'La création de contenu n\'a jamais été aussi smart.': 'La creazione di contenuti non è mai stata così intelligente.',
  'Boostez votre productivité grâce à la puissance multi-IA. Comparez et combinez les meilleures propositions issues de plusieurs LLM, puis optimisez-les grâce à un score de contenu en temps réel (SEO, lisibilité, pertinence)': 'Aumenta la tua produttività grazie alla potenza della multi-IA. Confronta e combina le migliori proposte di diversi LLM e ottimizzale con un punteggio del contenuto in tempo reale (SEO, leggibilità, pertinenza).',
  'Je crée mon premier contenu SEO friendly': 'Creo il mio primo contenuto SEO-friendly.',
  'Veuillez coller le texte source....': 'Incolla il testo originale che desideri tradurre…',
  'Enrichir': 'Arricchisci',
  'Veuillez d\'abord sélectionner un site web': 'Seleziona prima un sito web',

  "🎯 Commencez ici": "🎯 Inizia qui",
  "Ajoutez ou sélectionnez le site web que vous souhaitez suivre.": "Aggiungi o seleziona il sito web che desideri monitorare.",
  "📝 Derniers contenus créés": "📝 Ultimi contenuti creati",
  "Retrouvez ici les derniers contenus créés pour le site sélectionné.": "Trova qui gli ultimi contenuti creati per il sito selezionato.",
  "Cliquez sur un texte pour consulter sa fiche détaillée.": "Clicca su un testo per vedere i dettagli.",
  "📁 Derniers projets créés": "📁 Ultimi progetti creati",
  "Accédez rapidement aux derniers projets lancés pour ce site.": "Accedi rapidamente agli ultimi progetti avviati per questo sito.",
  "Cliquez sur un projet pour voir son avancement et les contenus associés.": "Clicca su un progetto per vederne l’avanzamento e i contenuti associati.",
  "📊 Suivi de vos projets": "📊 Monitoraggio dei tuoi progetti",
  "Visualisez la répartition de vos projets : en cours, en retard ou validés.": "Visualizza la distribuzione dei tuoi progetti: in corso, in ritardo o completati.",
  "Une vue d’ensemble claire pour suivre l’état global de votre production.": "Una visione chiara per monitorare lo stato generale della tua produzione.",
  "📑 Statut d’avancement des contenus": "📑 Stato di avanzamento dei contenuti",
  "Suivez ici la répartition de vos contenus : brouillons, livrés et publiés.": "Monitora qui la distribuzione dei tuoi contenuti: bozze, consegnati e pubblicati.",
  "Idéal pour identifier rapidement où concentrer vos efforts.": "Ideale per identificare rapidamente dove concentrare i tuoi sforzi.",
  "📅 Textes publiés par mois": "📅 Testi pubblicati per mese",
  "Visualisez le nombre de textes publiés chaque mois pour le site sélectionné.": "Visualizza il numero di testi pubblicati ogni mese per il sito selezionato.",
  "Suivez ainsi votre rythme de déploiement dans le temps.": "Segui così il tuo ritmo di pubblicazione nel tempo.",
  "⭐ Top mots-clés": "⭐ Top parole chiave",
  "Découvrez vos 5 mots-clés les plus performants issus de la Search Console.": "Scopri le tue 5 parole chiave più performanti dalla Search Console.",
  "Comparez leur position, les clics actuels et les clics de l’année précédente.": "Confronta la loro posizione, i clic attuali e quelli dell’anno precedente.",
  "📈 Activer le suivi du trafic": "📈 Attiva il monitoraggio del traffico",
  "Ajoutez notre adresse e-mail à votre Search Console pour activer cette analyse.": "Aggiungi la nostra email alla tua Search Console per attivare questa analisi.",
  "Vous pourrez ensuite suivre l’évolution de votre trafic directement dans Typix.": "Potrai poi monitorare l’evoluzione del traffico direttamente in Typix.",
  "🏠 Tableau de bord": "🏠 Dashboard",
  "Revenez à la vue globale : indicateurs clés, contenus récents, projets et performances de votre site.": "Torna alla vista globale: indicatori chiave, contenuti recenti, progetti e prestazioni del tuo sito.",
  "🤖 Agents IA": "🤖 Agenti IA",
  "Configurez et pilotez vos agents IA pour automatiser la rédaction ainsi que la traduction et gagner du temps sur vos contenus.": "Configura e gestisci i tuoi agenti IA per automatizzare la scrittura e la traduzione e risparmiare tempo sui contenuti.",
  "✍️ Rédaction IA": "✍️ Scrittura IA",
  "Accédez aux générateurs IA : fiches produit, fiches GMB, pages catégories et autres contenus optimisés.": "Accedi ai generatori IA: schede prodotto, schede GMB, pagine categoria e altri contenuti ottimizzati.",
  "🌍 Traduction IA": "🌍 Traduzione IA",
  "Traduisez vos contenus en plusieurs langues en quelques clics tout en conservant la cohérence SEO.": "Traduci i tuoi contenuti in più lingue in pochi clic mantenendo la coerenza SEO.",
  "➕ Créer un projet": "➕ Crea un progetto",
  "Lancez un nouveau projet de contenus en quelques secondes et suivez ensuite son avancement.": "Avvia un nuovo progetto di contenuti in pochi secondi e monitora poi il suo avanzamento.",
  "📂 Gestion des projets": "📂 Gestione dei progetti",
  "Accédez à vos projets non attribués, en cours, en retard ou validés pour suivre leur progression.": "Accedi ai tuoi progetti non assegnati, in corso, in ritardo o completati per seguirne l’avanzamento.",
  "👤 Mon profil": "👤 Il mio profilo",
  "Modifiez vos informations personnelles.": "Modifica le tue informazioni personali.",
  "🧑‍🤝‍🧑 Gestion des utilisateurs": "🧑‍🤝‍🧑 Gestione degli utenti",
  "Invitez de nouveaux membres, gérez leurs droits et organisez les équipes.": "Invita nuovi membri, gestisci i loro diritti e organizza le squadre.",
  "❓ Mon guide": "❓ La mia guida",
  "Relancez ce guide interactif à tout moment pour retrouver les principales fonctionnalités de Typix.": "Riavvia questa guida interattiva in qualsiasi momento per ritrovare le funzionalità principali di Typix.",
  'Mon guide': 'La mia guida',
  'Se déconnecter': 'Disconnettersi',
  "L'adresse email est obligatoire.": "L'indirizzo email è obbligatorio.",
  "Le nom est obligatoire.": "Il cognome è obbligatorio.",
  "Le prénom est obligatoire.": "Il nome è obbligatorio.",
  "Le mot de passe est obligatoire.": "La password è obbligatoria.",
  "La confirmation est obligatoire.": "La conferma è obbligatoria.",
  "Les mots de passe ne correspondent pas.": "Le password non corrispondono.",
  "Récapitulatif": "Riepilogo",
  "Quitter la création": "Esci dalla creazione",
  "Objectif du projet": "Obiettivo del progetto",
  "Mode de production": "Modalità di produzione",
  "Répartition du travail": "Ripartizione del lavoro",
  "Contexte éditorial": "Contesto editoriale",
  "Rédaction": "Scrittura",
  "Traduction": "Traduzione",
  "Créer du contenu original": "Crea contenuto originale",
  "Traduire un contenu existant": "Traduci contenuto esistente",
  "Identification du projet": "Identificazione del progetto",
  "Nom du projet": "Nome del progetto",
  "Vous pourrez modifier le nom plus tard": "Potrai modificare il nome in seguito",
  "URL du site": "URL del sito",
  "Langue": "Lingua",
  "Sélectionner une langue": "Seleziona una lingua",
  "Nombre de textes": "Numero di testi",
  "12 textes disponibles": "12 testi disponibili",
  "Chef de projet": "Project manager",
  "Aucun chef de projet assigné au siteweb": "Nessun project manager assegnato al sito web",
  "Sélectionner un chef de projet": "Seleziona un project manager",
  "Date limite du projet": "Scadenza del progetto",
  "Sélectionner une date limite": "Seleziona una scadenza",
  "Suivant": "Avanti",
  "Retour": "Indietro",
  "Définissez l'objectif et le cadre général de votre projet.": "Definisci l'obiettivo e il quadro generale del tuo progetto.",
  "IA": "IA",
  "Production généré par IA": "Produzione generata da IA",
  "Rédacteur": "Scrittore",
  "Production Rédacteur par IA": "Produzione scrittore tramite IA",
  "IA + revue humaine": "IA + revisione umana",
  "IA avec validation humaine.": "IA con validazione umana.",
  "Répartissez les textes de votre projet entre vous et d'éventuels rédacteurs.": "Distribuisci i testi del tuo progetto tra te e eventuali scrittori.",
  "L'attribution à un rédacteur est optionnelle.": "L'assegnazione a uno scrittore è opzionale.",
  "Agent IA": "Agente IA",
  "Vous pourrez changer d'agent plus tard": "Potrai cambiare agente in seguito",
  "Veuillez d'abord sélectionner un site web": "Seleziona prima un sito web",
  "Sélectionnez le mode IA": "Seleziona la modalità IA",
  "Aucun agent disponible": "Nessun agente disponibile",
  "Sélectionner un agent IA": "Seleziona un agente IA",
  "Format du contenu": "Formato del contenuto",
  "Sélectionner un format": "Seleziona un formato",
  "Nombre de mots par texte": "Numero di parole per testo",
  "Format personnalisé": "Formato personalizzato",
  "définir le nombre de mots": "definire il numero di parole",
  "mots": "parole",
  "Options avancées": "Opzioni avanzate",
  "Enrichissement du contenu": "Arricchimento del contenuto",
  "Génération Image": "Generazione di Immagini",
  "Nombre d’images": "Numero di Immagini",
  "Définir le nombre d’images": "Definire il numero di immagini",
  "Consomment des crédits supplémentaires": "Consumano crediti aggiuntivi",
  "IA augmentée par vos données": "IA potenziata con i tuoi dati",
  "Sélectionnez les personnes en charge de la relecture des contenus générés par l'IA et répartissez": "Seleziona le persone responsabili della revisione dei contenuti generati dall'IA e distribuisci",
  "les textes à valider.": "i testi da validare.",
  "Le relecteur peut apporter des corrections et ajustements ciblés dans la limite de mots définie,": "Il revisore può apportare correzioni e modifiche mirate entro il limite di parole definito,",
  "sans réécrire entièrement le contenu.": "senza riscrivere completamente il contenuto.",
  "Contexte éditorial & brief détaillé du projet": "Contesto editoriale e brief dettagliato del progetto",
  "Ajouter des informations contextuelles pour guider et enrichir la production des contenus.": "Aggiungi informazioni contestuali per guidare e arricchire la produzione dei contenuti.",
  "Gap sémantique": "Divario semantico",
  "optionnel": "opzionale",
  "Brief détaillé": "Brief dettagliato",
  "Lien drive...": "Link drive...",
  "Lancer le projet": "Avvia il progetto",
  "Nom du projet existant": "Nome progetto esistente",
  "Un projet avec ce nom existe déjà dans votre espace.": "Un progetto con questo nome esiste già nel tuo spazio.",
  "Merci de choisir un nom différent pour continuer.": "Scegli un nome diverso per continuare.",
  "Erreur lors de la création du projet. Veuillez réessayer.": "Errore durante la creazione del progetto. Riprova.",
  "Félicitations !": "Congratulazioni!",
  "Votre projet a été créé avec succès !": "Il tuo progetto è stato creato con successo!",
  "Voir le projet": "Vedi il progetto",
  "Paramètres du compte": "Impostazioni account",
  "Fermer": "Chiudi",
  "Site web": "Sito web",
  "Langue du site": "Lingua del sito",
  "textes": "testi",
  "Deadline": "Scadenza",
  "Type": "Tipo",
  "Rédacteur": "Scrittore",
  "Moi (par défaut)": "Io (predefinito)",
  "Livraison le": "Consegna il",
  "À venir": "In arrivo",
  "Production généré par IA": "Produzione generata da IA",
  "Agent": "Agente",
  "Format": "Formato",
  "Enrichissement du contenu activé": "Arricchimento contenuto attivato",
  "Relecteur": "Revisore",
  "texte": "testo",
  "Limite de modification": "Limite di modifica",
  "Aucune attribution": "Nessuna assegnazione",
  "Aucun élément ajouté": "Nessun elemento aggiunto",
  "janvier": "gennaio",
  "février": "febbraio",
  "mars": "marzo",
  "avril": "aprile",
  "mai": "maggio",
  "juin": "giugno",
  "juillet": "luglio",
  "août": "agosto",
  "septembre": "settembre",
  "octobre": "ottobre",
  "novembre": "novembre",
  "décembre": "dicembre",
  "à": "a",
  "mots minimum": "parole minime",
  "mots maximum": "parole massime",
  "Sans titre": "Senza titolo",
  "Status de validation des projets": "Stato di validazione dei progetti",
  "Statut d'avancement des contenus": "Stato di avanzamento dei contenuti:",
  "Total des contenus": "Totale contenuti:",
  "Non attribué": "Non assegnato",
  "Évolution des performances": "Evoluzione delle prestazioni",
  "Position": "Posizione",
  "Nombre de textes publiés": "Numero di testi pubblicati",
  "Espace de travail AI": "Spazio di lavoro AI",
  "Mise à jour 1.2": "Aggiornamento 1.2",
  "Découvrez les dernières fonctionnalités, optimisations et correctifs.": "Scopri le ultime funzionalità, ottimizzazioni e correzioni.",
  "Projet créé": "Progetto creato",
  "Votre projet a bien été créé.": "Il tuo progetto è stato creato correttamente.",
  "Vous pouvez commencer à travailler dessus dès maintenant.": "Puoi iniziare a lavorarci subito.",
  "Sélectionnez le mode IA": "Seleziona la modalità IA",
  "Aucun agent disponible": "Nessun agente disponibile",
  "Sélectionner un agent IA": "Seleziona un agente IA",
  "Sélectionner un format": "Seleziona un formato",
  "Veuillez d'abord sélectionner un site web": "Seleziona prima un sito web",
  'Nouveau contenu': 'Nuovo contenuto',
  'Génération en cours...': 'Generazione in corso...',
  'Optimisation en cours...': 'Ottimizzazione in corso...',
  'Traduction en cours...': 'Traduzione in corso...',
  'En lignes': 'Online',
  'filtres': 'Filtri',
  'trier par': 'Ordina per',
  'Score décroissant': 'Punteggio decrescente',
  'Score croissant': 'Punteggio crescente',
  'Date de création': 'Data di creazione',
  'Date de mise à jour': 'Data di aggiornamento',
  'Date récente': 'Data più recente',
  'Date ancienne': 'Data meno recente',
  'Mots clés': 'Parole chiave',
  'Éditeur': 'Editor',
  'Créateur': 'Creatore',
  'Rédacteurs': 'Redattori',
  'Réinitialisé par défaut': 'Ripristina impostazioni predefinite',
  'Mode de rédaction': 'Modalità di scrittura',
  'Agent AI utilisé': 'Agente AI utilizzato',
  'Textes en brouillons': 'Bozze',
  'Modèle': 'Modello',
  'Paramètres du projet': 'Impostazioni del progetto',
  'Avancement': 'Stato',
  'Progression': 'Avanzamento',
  'Aucun texte disponible': 'Nessun testo disponibile',
  'Détails du projet': 'Dettagli del progetto',
  'Page {{current}} sur {{total}}': 'Pagina {{current}} di {{total}}',
  'Moteur LLM': 'Motore LLM',
  'Rédiger un contenu': 'Scrivere un contenuto',
  'Traduire un contenu': 'Tradurre un contenuto',
  'Optimiser un contenu': 'Ottimizzare un contenuto',
  'Générer un contenu': 'Generare un contenuto',

  'Créez un texte pour un mot-clé spécifique avec un formulaire guidé':
    'Crea un testo per una parola chiave specifica con un modulo guidato',

  'Traduire un texte spécifique avec un formulaire guidé':
    'Traduci un testo specifico con un modulo guidato',

  'Générez plusieurs textes en important un fichier Excel':
    'Genera più testi importando un file Excel',

  'Rédiger un lot de contenus': 'Scrivere un lotto di contenuti',
  'Traduire un lot de contenus': 'Tradurre un lotto di contenuti',
  'Enrichir un contenu': 'Arricchire un contenuto',

  'Optimisez un texte spécifique avec un formulaire guidé':
    'Ottimizza un testo specifico con un modulo guidato',

  'Nombre total de textes alloués au projet':
    'Numero totale di testi assegnati al progetto',

  'Vous pourrez changer le format du contenu plus tard':
    'Potrai modificare il formato del contenuto in seguito',

  'Saisissez chaque mot-clé suivi de sa fréquence entre parenthèses, puis appuyez sur Entrée. Exemple : chaussures(3)':
    'Inserisci ogni parola chiave seguita dalla sua frequenza tra parentesi, quindi premi Invio. Esempio: scarpe(3)',

  'Ex: voiture(5), électrique(3), autonomie(8)':
    'Es: auto(5), elettrica(3), autonomia(8)',

  'URLs des pages à lier (séparées par des virgules)':
    'URL delle pagine da collegare (separate da virgole)',

  'Besoin d\'aide pour préparer votre fichier ?':
    'Hai bisogno di aiuto per preparare il tuo file?',

  'Télécharger le modèle (Excel)':
    'Scarica il modello (Excel)',

  'Déposez votre fichier ici':
    'Carica il tuo file qui',

  'Glissez-déposez votre fichier Excel':
    'Trascina e rilascia il file Excel',

  'ou cliquez pour parcourir':
    'o clicca per sfogliare',

  'Formats acceptés : .xlsx, .xls (max 10 Mo)':
    'Formati accettati: .xlsx, .xls (max 10 MB)',

  'Parcourir les fichiers':
    'Sfoglia i file',

  'Ex: télépéage automatique':
    'Es: telepedaggio automatico',

  'Générer le contenu': 'Genera il contenuto',
  'Lancer la génération': 'Avvia la generazione',
  'Commencer la traduction': 'Inizia la traduzione',
  'Lancer la traduction': 'Avvia la traduzione',

  'Partager': 'Condividi',
  'Telecharger le texte': 'Scarica il testo',
  'Modifier le projet': 'Modifica il progetto',
  'Modifiez les détails de votre projet ici.':
    'Modifica qui i dettagli del tuo progetto.',

  'Général': 'Generale',
  'Allocation des textes': 'Assegnazione dei testi',
  'Sélectionner un format du contenu': 'Seleziona un formato di contenuto',
  'Allocation aux rédacteurs': 'Assegnazione ai redattori',

  '{{count}} textes disponibles':
    '{{count}} testi disponibili',

  'Sélectionner un rédacteur': 'Seleziona un redattore',
  'Nom du rédacteur': 'Nome del redattore',
  'Date limite': 'Scadenza',
  'texte restant': 'testi rimanenti',
  'textes alloués': 'testi assegnati',

  'Article court - 300 mots': 'Articolo breve – 300 parole',
  'Article moyen - 600 mots': 'Articolo medio – 600 parole',
  'Article long - 1000 words': 'Articolo lungo – 1000 parole',
  'Youtube - 350 mots': 'YouTube – 350 parole',
  'Linkedin - 200 mots': 'LinkedIn – 200 parole',
  'X - 150 mots': 'X – 150 parole',
  'Personnalisé': 'Personalizzato',

'Voir plus': 'Vedi di più',
' à votre ': ' nel tuo ',
'{{count}} textes à livrer':
'{{count}} testi da consegnare',
'Nous contacter': 'Contattaci',
'Vous avez une question ou un problème ? Contactez-nous et nous vous répondrons dans les plus brefs délais.': 'Hai una domanda o un problema? Contattaci e ti risponderemo il prima possibile.',
'Sujet': 'Oggetto',
'Message': 'Messaggio',
'Soumettre ma demande': 'Invia la mia richiesta',
'Veuillez sélectionner un sujet': 'Seleziona un oggetto',
'Décrivez votre demande en détail...': 'Descrivi la tua richiesta in dettaglio...',
'Sélectionnez un sujet': 'Seleziona un oggetto',
'Autre': 'Altro',
'Feedback': 'Feedback',
'Question': 'Domanda',
'Bug': 'Bug',
'Le message doit contenir au moins 10 caractères': 'Il messaggio deve contenere almeno 10 caratteri',
'Votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais.': 'Il tuo messaggio è stato inviato con successo. Ti risponderemo il prima possibile.',
'Votre demande a bien été transmise à notre équipe support, qui vous répondra dans les plus brefs délais.': 'La tua richiesta è stata inoltrata al nostro team di supporto, che ti risponderà il prima possibile.',
'Envoi en cours...': 'Invio in corso...',
'Fermer': 'Chiudi',
'Créer un nouvel agent AI': 'Crea un nuovo agente AI',
'Mission de l\'agent': 'Missione dell\'agente',
'L\'agent générera du contenu original à partir de vos consignes.': 'L\'agente genererà contenuti originali sulla base delle tue istruzioni.',
'Informations générales': 'Informazioni generali',
'Informations principales': 'Informazioni principali',
'Ton & audience': 'Tono e pubblico',
'Structure & rédaction': 'Struttura e redazione',
'Base de connaissances': 'Base di conoscenza',
'Construction du contenu': 'Creazione del contenuto',
'Structure attendu': 'Struttura prevista',
'Cadre lexical': 'Quadro lessicale',
'Personnalisation avancée': 'Personalizzazione avanzata',
'Base de connaissance locale en ligne': 'Base di conoscenza locale online',
'Glissez-déposez votre fichier': 'Trascina e rilascia il tuo file',
'Base de connaissance': 'Base di conoscenza',
'Indiquez la liste des urls sur lesquels l’IA peut s’appuyer': 'Indica l\'elenco degli URL su cui l\'AI può fare affidamento',
'Définissez le positionnement éditorial de votre agent afin qu’il adapte son ton,': 'Definisci il posizionamento editoriale del tuo agente affinché adatti il suo tono,',
'sa cible et son vocabulaire à votre activité.': 'il suo target e il suo vocabolario alla tua attività.',
'caractères': 'caratteri',
};
